import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import DefaultLayout from '../../../Components/DefaultLayout';
import {
    Grid, Typography, Button, Autocomplete, TextField, Accordion,
    AccordionSummary,
    AccordionDetails, useMediaQuery, Divider,FormControlLabel,FormGroup,IconButton, Card, Stack, CardContent, Box, Tooltip, FormControl, InputLabel, Select, MenuItem, ListItemIcon, Checkbox, ListItemText, Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent, FormHelperText,FormLabel,RadioGroup,Radio } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import _, { isMap } from "lodash";
import { Chart } from "react-google-charts";
import { CardOverflow } from '@mui/joy';
import { currencyFormat } from '../../../Components/CommonFormula';
import { fetchData, postData } from '../../../redux/apiSlice';
import swal from "sweetalert";
import Moment from 'moment';
import config from '../../../AppConfig';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import AuthUser from '../../../Components/Auth/AuthUser';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core/styles';
import LogoEdit from '../../../Components/Cobrand/LogoEdit';
import dayjs from "dayjs";
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStyles, options } from "./utils";
import Slider from '@material-ui/core/Slider';
import Slide from '@mui/material/Slide';
import { CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { affiliateLogin } from '../../../redux/authSlice';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import ExapandVector from '../../../assets/images/ExapandVector.png';
import CloseIcon from '@mui/icons-material/Close';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Marquee from "react-easy-marquee";
const sliderStyle = makeStyles((theme) => ({
    root: {
        width: "100%",

    },

    margin: {
        height: 5,
    },
}));

function valuetext(value) {
    return `${value}`;
}


let gUserName = null;
let gUserPassword = null;
let gClientConcern = null;

const today = dayjs(new Date()).format("DD-MM-YYYY");
const current = new Date();
const GivenDate = dayjs(new Date()).format("08-MM-YYYY");
var companies = [];
var firstLetter = '';
let logoFlag = 0;
let errorMsg = "";
if (today < GivenDate) {
    current.setMonth(current.getMonth() - 2);
} else {
    current.setMonth(current.getMonth() - 1);
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="center" ref={ref} {...props} />;
});
function Dashboard() {

    
    const dispatch = useDispatch();
    const percentage = 75;
    const [companyList, setCompanyType] = useState([]);
    const theme = useTheme();
    const [dashboardList, setDashboardList] = React.useState([]);
    const [graphdeatail, setGraphDetails] = React.useState([]);
    const [userGraphdeatail, setUserGraphdeatail] = React.useState([]);
    const [retentionData, setRetentionData] = React.useState([]);
    const [AidList, SetAidList] = useState([]);
    const { user, loginAsAffiliate } = AuthUser();
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : '');
    const switchedAccount = localStorage.getItem('switchedAccount');
    const [visible, setVisible] = useState(user.roles_id === 3 && switchedAccount !== 'true');
    const [open, setOpen] = React.useState(false);
    const [commissionPopUp, setCommissionPopUp] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);
    const [openCalender, setOpencalender] = React.useState(false);
    const [refreshText, setRefreshText] = React.useState();
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('lg');
    const [selectedValue, setSelectedValue] = useState(null);
    const [affiliateLoginValue, setAffiliateLoginValue] = useState(false);
    const [bannerFlag, setBannerFlag] = useState(0);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [prodigyAcc, setProdigyAcc] = useState(false);
    const [marketingType, setMarketingType] = useState('');
    const [prodigyAccStatus, setProdigyAccStatus] = useState('');
    const [marketingTypeInText, setMarketingTypeInText] = useState('');
    const [paymentMadeEndedDate, setPaymentMadeEndedDate] = useState('');
    const [selectedRanges, setSelectedRanges] = useState([]);
    const [correctBankDetailsFlag, setCorrectBankDetailsFlag] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();
    //loader function and variable start
    const [freez, setFreez] = React.useState(false);
    const [accountConfirmationOpen, setAccountConfirmationOpen] = React.useState(false);
    const [createAccountConfirmationOpen, setCreateAccountConfirmationOpen] = React.useState(false);
    const [validateopen, setValidateOpen] = React.useState(false);
    const [userName, setUserName] = React.useState(null);
    const [userPassword, setUserPassword] = React.useState(null);
    const [softwareAccount, setSoftwareAccount] = React.useState(false);
    const [createAccountFlag, setCreateAccountFlag] = React.useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [createAccountOpen, setCreateAccountOpen] = React.useState(false);
    const [profilePercentage, setProfilePercentage] = React.useState();
    const [offer, setOffer] = React.useState(null);
    const [currentMonthOffer, setCurrentMonthOffer] = React.useState(null);
    const [membersActiveCount, setMembersActiveCount] = React.useState("");
    const [targetStatus, setTargetStatus] = React.useState(null);
    const [currentDate, setCurrentDate] = useState("");
    const [companyLogoSlider, setCompanyLogoSlider] = useState([])
    const [currentMonth, setCurrentMonth] = useState("")
    const [targetPercentage, seTargetPercentage] = useState("")
    const [currentMonthAchievers, setCurrentMonthAchievers] = useState("");
    // const marqueeRef = useRef(null);
    const [isAchiever, setIsAchiever] = useState(0);
    const [targetCommission, setTargetCommission] = useState(0);
    const [minTarget, setMinTarget] = useState(0);
    const [maxTarget, setMaxTarget] = useState(0);
    const [newTarget, setNewTarget] = useState(0);
    const [sliderValue, setSliderValue] = useState(0);
    const [targetDiff, setTargetDiff] = useState(0);
    const [lastDayOfMonth, setLastDayOfMonth] = useState();
    const [suffixoflastDayOfMonth, setSuffixoflastDayOfMonth] = useState();
    const [taxFlag, setTaxFlag] = useState(false);
    const Sliderclasses = sliderStyle();
    const myDate = new Date();
    myDate.setDate(myDate.getDate());
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const lastDay = new Date(year, month, 0);
    let cDate = Moment(myDate).tz('America/Los_Angeles').format('MM-DD-YY');
    let monthName = Moment(myDate).tz('America/Los_Angeles').format('MMMM');
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const [openFire, setOpenFire] = React.useState(false);
    const [holidayDates, setHolidayDates] = React.useState([]);
    const [open1099Details, setOpen1099Details] = useState(false);
    const handle1099DetailsClose = () => setOpen1099Details(false);
    const [companyTaxDetails, setCompanyTaxDetails] = useState([]);
    const [currentMonthCommission, setCurrentMonthCommission] = React.useState(0);
    const [currentMonthCommissionUpdated, setCurrentMonthCommissionUpdated] = React.useState(0);
    const generateMarks = () => {
        let min = minTarget % 100 < 50
            ? Math.floor(minTarget / 100) * 100 + 50
            : Math.ceil(minTarget / 100) * 100;

        return Array.from({ length: Math.floor((maxTarget - min) / 100) + 1 }, (_, i) => ({
            value: min + i * 100,
            label: ('$' + (min + i * 100)).toString(),
        }));
    };

    const marks = useMemo(() => generateMarks(), [minTarget, maxTarget]);
    const handleSliderChange = useCallback((event, newValue) => {
        setTimeout(() => {
            setSliderValue(newValue);

            // Ensure state values are always fresh
            setNewTarget(prevNewTarget => {
                const newTargetValue = Math.round(parseFloat(newValue) / parseFloat(currentMonthOffer.per_enrollment_commission * 25 / 100));
                return newTargetValue;
            });

            setTargetDiff(prevTargetDiff => {
                const newTargetValue = Math.round(parseFloat(newValue) / parseFloat(currentMonthOffer.per_enrollment_commission * 25 / 100));
                return parseInt(newTargetValue) - parseInt(membersActiveCount);
            });

            setTargetStatus(prevTargetStatus => {
                const newTargetValue = Math.round(parseFloat(newValue) / parseFloat(currentMonthOffer.per_enrollment_commission * 25 / 100));
                return parseInt(newTargetValue) - parseInt(membersActiveCount) > 0 ? "Below" : "Above";
            });

            setCurrentMonthCommissionUpdated(prevCurrentMonthCommissionUpdated => {
                const newTargetValue = Math.round(parseFloat(newValue) / parseFloat(currentMonthOffer.per_enrollment_commission * 25 / 100));
                const newCurrentMonthCommission = Math.round((currentMonthOffer.per_enrollment_commission * newTargetValue)); 
                const newCurrentMonthCommissionUpdated = Math.round(parseFloat(newValue) + parseFloat(newCurrentMonthCommission) + parseFloat(dashboardList.currentMonthReferralCommission) + parseFloat(dashboardList.currentMonthInitialBonus));
                return newCurrentMonthCommissionUpdated;
            });

            setCurrentMonthCommission(prevCurrentMonthCommission => {
                const newTargetValue = Math.round(parseFloat(newValue) / parseFloat(currentMonthOffer.per_enrollment_commission * 25 / 100));
                const newCurrentMonthCommission = Math.round(parseFloat(currentMonthOffer.per_enrollment_commission * newTargetValue) + parseFloat(dashboardList.currentMonthReferralCommission) + parseFloat(dashboardList.currentMonthInitialBonus)); 
                return newCurrentMonthCommission;
            });

        }
            , 1000);
    }, [currentMonthOffer, membersActiveCount, currentMonthCommission]);

    const saveNewTarget = async () => {
        const apiUrl = '/update-commission-target-value'; // Replace with your API endpoint
        const args = {
            newTarget: newTarget,
            companyId: companyId,
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            handleFreezStop();
            if (res.success === true) {
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
                fetchDashboardList("all", companyId);
            } else {
                swal({
                    title: "Failed",
                    text: res.message,
                    icon: "error",
                    button: "Ok",
                })
            }
        }
    };
    const handleClickOpenFire = () => {
        setOpenFire(true);
    };

    const handleCloseFire = () => {
        setOpenFire(false);
    };

    const accountSchema = Yup.object().shape({
        username: Yup.string()
            .matches(
                /^[A-Za-z0-9_@#$%&()'\-.]+(?: [A-Za-z0-9_@#$%&()'\-.]+)*$/,
                'Please enter a valid User Name'
            )
            .min(5, 'User Name must be at least 5 characters')
            .required('Please enter User Name.'),

        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Please enter password.'),

        clientConcern: Yup.string()
            .required('Please Choose One.'),
    });

    const handleValidateClose = () => {
        setValidateOpen(false);
    };

    const validateAccount = async (values) => {

        const apiUrl = '/validateProdigyAccount'; // Replace with your API endpoint
        const args = {
            username: gUserName,
            password: gUserPassword,
            companyId: companyId,
            clientConcern: values.clientConcern
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            handleFreezStop();
            if (res.success === true) {
                errorMsg = "";
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
                fetchDashboardList("all", companyId);
            } else {
                errorMsg = res.message;
                setTimeout(function () {
                    errorMsg = "";
                }, 1000);
                setValidateOpen(true);
            }
        }
    };

    const createProdigyAccount = async (values) => {

        const apiUrl = '/create-affiliate-prodigy-account'; // Replace with your API endpoint
        const args = {
            username: gUserName,
            password: gUserPassword,
            companyId: companyId,
            clientConcern: values.clientConcern
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            // setIsLoading(false);
            handleFreezStop();
            if (res.success === true) {
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
                fetchDashboardList("all", companyId);
            } else {
                swal({
                    title: "Failed",
                    text: res.message,
                    icon: "error",
                    button: "Ok",
                })
            }
        }

    };

    const admin = useSelector((state) => JSON.parse(state.auth.admin));
    //graph options


    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    //loader function and variable end
    //logo editor function and variale start
    const [uploadLogo, setUploadLogo] = React.useState(false);
    const [companylogo, setCompanyLogo] = useState();
    const [logoType, setLogoType] = useState();
    const [logoText, setLogoText] = useState();
    const handleLogoFlag = (flag) => {
        logoFlag = flag;
    }

    const handleLogoURL = (image) => {
        setCompanyLogo(image);

    }
    // const handleFullWidthChange = (event) => {
    //   setFullWidth(event.target.checked);
    // };
    const handleCloseUploadLogo = (value) => {
        setUploadLogo(false);
    }

    const handleClose3 = () => {
        setOpen3(false);
    };
    const classes = useStyles();
    const [selected, setSelected] = useState([]);
    const [bankStatus, setBankStatus] = useState();
    const [value, setValue] = React.useState();
    const [companyAdmins, setCompanyAdmins] = React.useState(null);
    const isAllSelected = AidList.length > 0 && selected.length === AidList.length;
    
    const companyDetails = JSON.parse(localStorage.getItem('company'));
    const [balance, setBalance] = useState(false);
    const [scrollX, setScrollX] = useState(0);

    const handleChange1 = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            setSelected(selected.length === AidList.length ? [] : AidList);
            fetchDashboardList("all", companyId);
            return;
        }
        setSelected(value);
        fetchDashboardList(value, companyId);
    };
    const mobileDialogModalStyles = {
        position: 'absolute',
        left: `${scrollX}px`,
    };

    // API Call Dashboard
    const fetchCompanyList = async () => {
        handleFreezStart();
        const apiUrl = '/fetchCompanyList'; // Replace with your API endpoint
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            handleFreezStop();
            setCompanyType(res.data);
            companies = res.data.map((option) => {
                firstLetter = option.company_name[0].toUpperCase();
                return {
                    firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
                    ...option,
                };
            });
            companies = companies.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))
            setSelectedValue(companies[0]);
            var defaultCompanyId = companies[0].id;
            setValue(defaultCompanyId);
            getCompanyLogoList();
            fetchAidList(defaultCompanyId);
            fetchDashboardList("all", defaultCompanyId);
            setCompanyId(defaultCompanyId);
        }

    }

    const handleAffiliateLogin = async () => {
        const apiUrl = '/fetchCompanyAdmins/' + companyId; // Replace with your API endpoint
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setCompanyAdmins(res.data);
            setAffiliateLoginValue(true);
        }
    }

    const assignCompanyAdmin = Yup.object().shape({
        companyAdminId: Yup.string()
            .required('Please select User to Login.'),
    });
    const fetchAidList = async (id) => {
        handleFreezStart();
        setSelected([])
        const apiUrl = '/fetchCompanyAidList/' + id; // Replace with your API endpoint
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            // handleFreezStop();
            SetAidList(res.aidList);
            // Fetch a list of elements
            const elementsList = res.aidList.map(row => row); // Fetches the element at column 2 from each row
            // Create a 2D array from the list
            const twoDArray = elementsList.map(element => [element]); // Creates a new row for each element
            SetAidList(twoDArray);
            setSelected(twoDArray);
        }
    }
    const fetchDashboardList = async (value, id) => {
        handleFreezStart();
        let simpleArray = [];
        if (value != "all") {
            simpleArray = value.flat();
        }
        const apiUrl = '/getDashboardData'; // Replace with your API endpoint
        const args = {
            aid: simpleArray.length > 0 ? simpleArray : value,
            companyId: id
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            handleFreezStop();
            // setIsLoading(false)
            setBannerFlag(res.data.bannerFlag);
            setDashboardList(res.data);
            setGraphDetails(res.data.graphDetails);
            setUserGraphdeatail(res.data.userGraphDetails);
            setRetentionData(res.data.retention_percentage ? res.data.retention_percentage : false);
            setCompanyLogo(res.data.companyLogoUrl);
            setLogoType(res.data.check_logo_type);
            setLogoText(res.data.default_logo_text);
            setProdigyAcc(res.data.prodigyAcc);
            setMarketingType(res.data.marketingType == "ProdigySurge" || res.data.marketingType == "ProdigySurgePromo" ? "ProdigySurge" : res.data.marketingType);
            setProdigyAccStatus(res.data.prodigyAccStatus);
            setOffer(res.data.offer);
            setCurrentMonthOffer(res.data.currentMonthOffer);
            setCurrentMonthCommission(Math.round(res.data.currentMonthCommission));
            setCurrentDate(res.data.currentDate);
            if (res.data.currentMonthOffer) {
                var targetValue = res.data.currentMonthOffer.changed_target_active_enrollments ? res.data.currentMonthOffer.changed_target_active_enrollments : res.data.currentMonthOffer.target_active_enrollments;
                var minTargetValue =  res.data.currentMonthOffer.target_active_enrollments;
                var temp = Math.round(parseFloat(res.data.currentMonthOffer.per_enrollment_commission * 25 / 100) * parseFloat(targetValue));
                var temp2 = Math.round(parseFloat(res.data.currentMonthOffer.per_enrollment_commission * 25 / 100) * parseFloat(minTargetValue));
                setTargetCommission(temp);
                setMinTarget(parseFloat(temp2));
                setSliderValue(parseFloat(temp));
                setCurrentMonthCommissionUpdated(Math.round(parseFloat(temp) + parseFloat(res.data.currentMonthCommission)));
                const tempMax = parseFloat(temp2) + 500.00;
                const roundedMaxTarget = Math.ceil(tempMax / 100) * 100;
                setMaxTarget(roundedMaxTarget);
                setNewTarget(targetValue);
                if (parseInt(targetValue) - parseInt(res.data.membersActiveCount) > 0) {
                    setTargetDiff(parseInt(targetValue) - parseInt(res.data.membersActiveCount));
                }
            }
            setMembersActiveCount(res.data.membersActiveCount);
            if (res.data.currentMonthOffer != null) {
                if (parseFloat(targetValue) <= parseFloat(res.data.membersActiveCount)) {
                    setTargetStatus("Above");
                    if (user.roles_id == 3) {
                        var storageIsAchiever = localStorage.getItem("isAchiever");
                        var newStorageIsAchiever;
                        console.log("storageIsAchiever:" + storageIsAchiever);
                        if (storageIsAchiever == null) {
                            setIsAchiever(1);
                            newStorageIsAchiever = 1;
                        } else {
                            newStorageIsAchiever = parseInt(storageIsAchiever) + 1;
                            setIsAchiever(newStorageIsAchiever);
                        }
                        localStorage.setItem("isAchiever", newStorageIsAchiever);
                        if (newStorageIsAchiever == 1) {
                            // setOpenFire(true);
                        }

                    }



                } else {
                    setTargetStatus("Below")
                }
                const targetMonthNumber = new Date(`${res.data.currentMonthOffer.target_month} 1, ${res.data.currentMonthOffer.target_year}`).getMonth() + 1;
                const lastDate = new Date(res.data.currentMonthOffer.target_year, targetMonthNumber, 0).getDate();
                setLastDayOfMonth(lastDate);
                var suffix = '';
                if (lastDate > 3 && lastDate < 21) {
                    suffix = "th"; // 4th to 20th are "th"
                }
                switch (lastDate % 10) {
                    case 1: suffix = "st";
                    case 2: suffix = "nd";
                    case 3: suffix = "rd";
                    default: suffix = "th";
                }
                setSuffixoflastDayOfMonth(suffix);
            }

            var flagTotal = res.data.cobrandingFlag + res.data.refferalFlag + res.data.snapshotFlag + res.data.bankdetailsFlag + res.data.advancedCobrandSetUpFlag;
            if (res.data.prodigyAcc && res.data.prodigyAccStatus != null) {
                if (res.data.prodigyAccStatus == "created") {
                    flagTotal += 1;
                }
                var calculatedPercentage = (((100 / 6) * flagTotal).toFixed(2));
            } else {
                var calculatedPercentage = (((100 / 5) * flagTotal).toFixed(2));
            }

            if (calculatedPercentage.endsWith('.00')) {
                setProfilePercentage(parseInt(calculatedPercentage, 10));
            } else {
                setProfilePercentage(calculatedPercentage);
            }
            if (res.data.taxDetails !== null) {
                setTaxFlag(true);
            }
            var affTaxFlag = localStorage.getItem("taxFlag");
            // if(affTaxFlag == 2 && res.data.taxDetails != null) {
            //   setCompanyTaxDetails(res.data.taxDetails);
            //   setOpen1099Details(true);
            // }
            // if(res.data.targetCommission > 0 && user.roles_id == 3) {
            //   setOpenFire(true);
            // }
            if (res.data.acceptedFlag == true) {
                setBalance(res.data.balance);
                setBankStatus(res.data.bankStatus);
                setOpen(true);
            } 

        }

    }
    const acceptCommission = async () => {
        setCorrectBankDetailsFlag(true);
        handleFreezStart();
        const apiUrl = '/affiliate/accept-commission'; // Replace with your API endpoint
        const args = {
            companyId: companyId
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            handleFreezStop();
            if (res.success === true) {
                setOpen(false);
                setOpencalender(true);
                setPaymentMadeEndedDate(res.data.paymentMadeEndedDate);
                setHolidayDates(res.data.holidays);
                setSelectedRanges([
                    { start: res.data.acceptedDate, end: res.data.acceptedDate, color: 'highlight0' },
                    { start: res.data.verifiedStartedDate, end: res.data.verifiedMiniEndedDate, color: 'highlight2' },
                    { start: res.data.paymentMadeStartedDate, end: res.data.paymentMadeEndedMiniEndedDate, color: 'highlight1' },
                    { start: res.data.verifiedEndedDate, end: res.data.verifiedEndedDate, color: 'darkOrange' },
                    { start: res.data.paymentMadeEndedDate, end: res.data.paymentMadeEndedDate, color: 'darkGreen' },
                ])
            } else {
                swal({
                    title: "Failed",
                    text: res.message,
                    icon: "error",
                    button: "Ok",
                })
                if (res.message == "This action is unauthorized.") {
                    navigate('/login');
                }
            }
        }

    };


    const handleClose = () => {
        setOpen(false);
    };
    const handleClsoeCalender = () => {
        setOpencalender(false);
    }
    const handleClose1 = () => {
        setOpen1(false);
    };

    const setProdigyAccount = () => {
        setAccountConfirmationOpen(true);
    }

    const handleCreateNewAccountClose = () => {
        setCreateAccountOpen(false);
    };

    const handleAccountConfirmation = async () => {
        setAccountConfirmationOpen(false);
        errorMsg = "";
        setSoftwareAccount(true);
        setValidateOpen(true);
    }

    const closeAccountCofirmation = () => {
        setAccountConfirmationOpen(false);
        errorMsg = "";
        setCreateAccountConfirmationOpen(true);
        setSoftwareAccount(false);
    };

    const closeCreateAccountCofirmation = () => {
        setCreateAccountConfirmationOpen(false);
        setCreateAccountFlag(false);
    };

    const createAccount = async () => {
        setCreateAccountConfirmationOpen(false);
        setCreateAccountFlag(true);
        setCreateAccountOpen(true);
    }

    useEffect(() => {
        fetchCompanyList();
        // setCurrentDate(cDate);
        if (user.roles_id < 3) {

        }
        if (user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5) {
            setCompanyId(user.company_master_id);
            fetchAidList(user.company_master_id);
        }
    }, [])

    const handleInputChange = (event, value) => {
        if (value && value.id) {
            // Handle the change event here
            setCompanyId(value.id);
            fetchAidList(value.id);
            setSelectedValue(value);
            fetchDashboardList("all", value.id);
        }
    };


    const tileClassName = ({ date }) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');

        if (holidayDates.includes(formattedDate)) {
            return 'holidayColor';  // Use a specific color for holidays
        }

        for (const range of selectedRanges) {
            const { start, end, color } = range;
            if (color != 'highlight0') {
                // Check if the date is a weekend (Saturday or Sunday)
                const isWeekend = moment(formattedDate).isoWeekday() === 6 || moment(formattedDate).isoWeekday() === 7;

                if (moment(formattedDate).isBetween(start, end, null, '[]') && !isWeekend) {
                    return color;
                }
            }
            else if (moment(formattedDate).isBetween(start, end, null, '[]')) {
                return color;
            }
        }

        return null;
    };

    const getCompanyLogoList = async () => {
        handleFreezStart();
        const apiUrl = '/getTargetAchieversList';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setCompanyLogoSlider(res.data.commissionTargets);
            setCurrentMonth(res.data.currentMonth);
            seTargetPercentage(res.data.percentage);
            setCurrentMonthAchievers(res.data.currentMonthAchievers);
        }

    };


   
    function Separator(props) {
        return (
            <div
                style={{
                    position: "absolute",

                    height: "100%",
                    transform: `rotate(${props.turns}turn)`
                }}
            >
                <div style={props.style} />
            </div>
        );
    }

    function RadialSeparators(props) {
        const turns = 1 / props.count;
        return _.range(props.count).map((index) => (
            <Separator key={index} turns={index * turns} style={props.style} />
        ));
    }
    // dashboard confitty code start here

    useEffect(() => {
        let timer;
        if (openFire) {
            timer = setTimeout(() => {
                setOpenFire(false);
                if (commissionPopUp == true) {
                    setOpen(true);
                }
            }, 10000);
        }
        return () => clearTimeout(timer);
    }, [openFire]);

    const [showText, setShowText] = useState(false);
    const [showGif, setShowGif] = useState(true);


    const hasUpdated = useRef(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!hasUpdated.current) {
                console.log("Hi");
                setShowGif(false);
                setShowText(true);
                hasUpdated.current = true;
            }
        }, 9000);

        return () => clearTimeout(timer);
    }, []);

    // dashboard confitty code end here
    const graphOptions = {
        seriesType: "bars",

        colors: ["#51D422", "#2275D4"],
        series: {
            0: {
                targetAxisIndex: 0
            },
            1: {
                targetAxisIndex: 1
            }
        },
        focusTarget: 'category',
        // Use an HTML tooltip.
        tooltip: { isHtml: true },
    };



    const Slide1 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage: isMobile?`url(${require('../../../assets/images/BannerImage1Mob.png')})`: `url(${require('../../../assets/images/BannerImage1Desk.png')})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
            <Grid display={'flex'} flexDirection={'column'} alignItems={isMobile?"end":"center"} justifyContent={isMobile?"end":"center"} sx={{padding:'2%'}}>
                <Grid display={'flex'} flexDirection={isMobile?"column":'row'} alignItems={isMobile?"end":"center"} justifyContent={isMobile?"end":'space-evenly'} gap={isMobile?1:2}>
                    <Typography variant={"h5"} align={isMobile?"end":"center" } fontWeight={"bolder"} color={'white'} gutterBottom>
                        Unlock FREE Leads And <br/> More MONEY $$$ With
                    </Typography>
                    <img
                        src={require('../../../assets/images/fundingWhite.png')}
                        alt="Funding Shot"
                        style={{ height:isMobile?"50px": "80%", objectFit: "contain" }}
                    />
                </Grid>
                <Grid display={'flex'} flexDirection={isMobile?"column":'row'} alignItems={isMobile?"end":"center"} justifyContent={isMobile?"flex-end":'space-evenly'} gap={2} mt={1}>
                    <Button variant="contained" size='large' 
                        sx={{
                            backgroundColor:"#58DE30",
                            color:"black",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#58DE30", 
                                color: "black",             
                            },
                        }}
                            onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More</Button>
                    <Button variant="contained" size="large" 
                        sx={{
                            backgroundColor:"#58DE30",
                            color:"black",
                            fontWeight:"800",
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#58DE30",
                                color: "black",        
                            },
                        }}
                        onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now</Button>
                </Grid>
            </Grid>

            </Box>
        </Grid>
    );
    
    const Slide2 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage:isMobile?`url(${require('../../../assets/images/BannerImage2Mob.png')})`:  `url(${require('../../../assets/images/BannerImage2Desk.png')})`,
                    backgroundSize: isMobile? "cover": "contain",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <Grid display={'flex'} flexDirection={'column'} alignItems={"start"} justifyContent={isMobile?"end":"center"} sx={{padding:isMobile?'1%':'1% 5%'}}>
                    <Grid display={'flex'} flexDirection={"column"} alignItems={"start"} justifyContent={'space-evenly'} >
                        <Grid display={'flex'} flexDirection={isMobile?"column":"row"} alignItems={isMobile?"start":"center"} gap={isMobile?0:2} >
                            <Typography variant={isMobile?"h6":"h5"} fontWeight={"bolder"} gutterBottom color={"white"} 
                                sx={{lineHeight:1}}>
                                BUILD, GROW & SCALE WITH
                            </Typography>						
                            <img
                                src={require('../../../assets/images/fundingWhite.png')}
                                alt="Funding Shot"
                                style={{ height:isMobile?"50px": "80%", objectFit: "contain" }}
                            />
                        </Grid>
                        <Typography variant='body1' fontWeight={"bolder"} color={"white"} >
                            Get Real Business Funding Estimates Based <br/>On Real Lender Criteria
                        </Typography>
                    </Grid>
                    <Grid display={'flex'} flexDirection={isMobile?"column":'row'} alignItems={isMobile?"start":"center"} justifyContent={isMobile?"flex-end":'space-evenly'} gap={isMobile?1:2} mt={1}>
                        <Button variant="contained" 
                            sx={{
                                backgroundColor:"#00318E",
                                color:"white",
                                fontWeight:"800", 
                                fontSize: 'medium',
                                textTransform:"capitalize",
                                "&:hover": {
                                    backgroundColor: "#00318E", 
                                    color: "white",             
                                },
                            }}
                            onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More
                        </Button>						
                        <Button variant="contained" 
                            sx={{
                                backgroundColor:"#00318E",
                                color:"white",
                                fontWeight:"800", 
                                fontSize: 'medium',
                                textTransform:"capitalize",
                                "&:hover": {
                                    backgroundColor: "#00318E", 
                                    color: "white",             
                                },
                            }}
                            onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now</Button>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );

    const Slide3 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage:isMobile?`url(${require('../../../assets/images/BannerImage3Mob.png')})`:  `url(${require('../../../assets/images/BannerImage3Desk.png')})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",					   
                }}
            >
            <Grid display={'flex'} flexDirection={'column'} alignItems={"end"} justifyContent={isMobile?"end":"center"} sx={{padding:'2%'}}>
                <Grid display={'flex'} flexDirection={isMobile?"column":'row'} alignItems={isMobile?"end":"center"} justifyContent={'space-evenly'} gap={isMobile?0:1}>
                    <Typography variant={isMobile?"body2":"h6"} align={isMobile?"end":"center"} fontWeight={"bolder"} gutterBottom color={"white"}>
                        Drive Revenue Growth With Every<br />Funding Estimate You Deliver With 
                    </Typography>
                    <img
                        src={require('../../../assets/images/fundingWhite.png')}
                        alt="Funding Shot"
                        style={{ height:isMobile?"50px": "80%", objectFit: "contain" }}
                    />
                </Grid>
                <Grid display={'flex'} flexDirection={isMobile?"column":'row'} alignItems={isMobile?"end":"center"} justifyContent={isMobile?"flex-end":'space-evenly'} gap={isMobile?1:2} mt={1}>
                    <Button variant="contained" 
                        sx={{
                            backgroundColor:"#00318E",
                            color:"white",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#00318E", 
                                color: "white",             
                            },
                        }}
                        onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More
                    </Button>						
                    <Button variant="contained" 
                        sx={{
                            backgroundColor:"#00318E",
                            color:"white",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#00318E", 
                                color: "white",             
                            },
                        }}
                        onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now
                    </Button>
                </Grid>
            </Grid>

            </Box>
        </Grid>
    );

    const FundingSlide1 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage:`url(${require('../../../assets/images/BannerImage1Mob.png')})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
            <Grid display={'flex'} flexDirection={'column'} alignItems={"end"} justifyContent="end" sx={{padding:'2%'}}>
                <Grid display={'flex'} flexDirection={"column"} alignItems={"end"} justifyContent={"end"} gap={1}>
                    <Typography variant={"h5"} align={"end"} fontWeight={"bolder"} color={'white'} gutterBottom>
                        Unlock FREE Leads And <br/> More MONEY $$$ With
                    </Typography>
                    <img
                        src={require('../../../assets/images/fundingWhite.png')}
                        alt="Funding Shot"
                        style={{ height:"50px", objectFit: "contain" }}
                    />
                </Grid>
                <Grid display={'flex'} flexDirection={"column"} alignItems={"end"} justifyContent={"flex-end"} gap={2} mt={1}>
                    <Button variant="contained" size='large' 
                        sx={{
                            backgroundColor:"#58DE30",
                            color:"black",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#58DE30", 
                                color: "black",             
                            },
                        }}
                            onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More</Button>
                    <Button variant="contained" size="large" 
                        sx={{
                            backgroundColor:"#58DE30",
                            color:"black",
                            fontWeight:"800",
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#58DE30",
                                color: "black",        
                            },
                        }}
                        onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now</Button>
                </Grid>
            </Grid>

            </Box>
        </Grid>
    );
    
    const FundingSlide2 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage:`url(${require('../../../assets/images/BannerImage2Mob.png')})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    height: '265px'
                }}
            >
                <Grid display={'flex'} flexDirection={'column'} alignItems={"start"} justifyContent={"end"} sx={{padding:'1%'}}>
                    <Grid display={'flex'} flexDirection={"column"} alignItems={"start"} justifyContent={'space-evenly'} >
                        <Grid display={'flex'} flexDirection={"column"} alignItems={"start"} gap={0} >
                            <Typography variant={"h6"} fontWeight={"bolder"} gutterBottom color={"white"} 
                                sx={{lineHeight:1}}>
                                BUILD, GROW & SCALE WITH
                            </Typography>						
                            <img
                                src={require('../../../assets/images/fundingWhite.png')}
                                alt="Funding Shot"
                                style={{ height:"50px", objectFit: "contain" }}
                            />
                        </Grid>
                        <Typography variant='body1' fontWeight={"bolder"} color={"white"} >
                            Get Real Business Funding Estimates Based <br/>On Real Lender Criteria
                        </Typography>
                    </Grid>
                    <Grid display={'flex'} flexDirection={"column"} alignItems={"start"} justifyContent={"flex-end"} gap={1} mt={1}>
                        <Button variant="contained" 
                            sx={{
                                backgroundColor:"#00318E",
                                color:"white",
                                fontWeight:"800", 
                                fontSize: 'medium',
                                textTransform:"capitalize",
                                "&:hover": {
                                    backgroundColor: "#00318E", 
                                    color: "white",             
                                },
                            }}
                            onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More
                        </Button>						
                        <Button variant="contained" 
                            sx={{
                                backgroundColor:"#00318E",
                                color:"white",
                                fontWeight:"800", 
                                fontSize: 'medium',
                                textTransform:"capitalize",
                                "&:hover": {
                                    backgroundColor: "#00318E", 
                                    color: "white",             
                                },
                            }}
                            onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now</Button>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );

   const FundingSlide3 = () => (
        <Grid container>
            <Box
                sx={{
                    width: "100%",
                    backgroundImage:`url(${require('../../../assets/images/BannerImage3Mob.png')})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",	
                    height: '265px'				   
                }}
            >
            <Grid display={'flex'} flexDirection={'column'} alignItems={"end"} justifyContent={"end"} sx={{padding:'2%'}}>
                <Grid display={'flex'} flexDirection={"column"} alignItems={"end"} justifyContent={'space-evenly'} gap={0}>
                    <Typography variant={"body2"} align={"end"} fontWeight={"bolder"} gutterBottom color={"white"}>
                        Drive Revenue Growth With Every<br />Funding Estimate You Deliver With 
                    </Typography>
                    <img
                        src={require('../../../assets/images/fundingWhite.png')}
                        alt="Funding Shot"
                        style={{ height:"50px", objectFit: "contain" }}
                    />
                </Grid>
                <Grid display={'flex'} flexDirection={"column"} alignItems={"end"} justifyContent={"flex-end"} gap={1} mt={1}>
                    <Button variant="contained" 
                        sx={{
                            backgroundColor:"#00318E",
                            color:"white",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#00318E", 
                                color: "white",             
                            },
                        }}
                        onClick={() => navigate(window.open("http://fundingsnapshot.com/", "_blank"))}>Learn More
                    </Button>						
                    <Button variant="contained" 
                        sx={{
                            backgroundColor:"#00318E",
                            color:"white",
                            fontWeight:"800", 
                            fontSize: 'medium',
                            textTransform:"capitalize",
                            "&:hover": {
                                backgroundColor: "#00318E", 
                                color: "white",             
                            },
                        }}
                        onClick={() => navigate("/affiliate/creditsnapshot/")}>Get FREE Funding Snapshot Leads Now
                    </Button>
                </Grid>
            </Grid>

            </Box>
        </Grid>
    );

        const [currentSlide, setCurrentSlide] = useState(0);

            const slides = [<Slide1 />, <Slide2 />, <Slide3 />];

            const nextSlide = () => {
            setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
            };

            const prevSlide = () => {
            setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
            };

        const [fudingCurrentSlide, setFudingCurrentSlide] = useState(0);

        const fundingSlides = [<FundingSlide1 />, <FundingSlide2 />, <FundingSlide3 />];

        const fundingNextSlide = () => {
        setFudingCurrentSlide((prev) => (prev === fundingSlides.length - 1 ? 0 : prev + 1));
        };

        const fundingPrevSlide = () => {
        setFudingCurrentSlide((prev) => (prev === 0 ? fundingSlides.length - 1 : prev - 1));
        };

    // Auto-scroll effect
    useEffect(() => {
    //   const interval = setInterval(() => {
    //     nextSlide();
    //   }, 10000); // 5000ms = 5 seconds

    //   return () => clearInterval(interval); // Clear on unmount
    }, []);

    function ContentLayout() {
        return (
            <>
                <Box sx={{ padding: isMobile ? 0: 1 }}>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                        { companyLogoSlider?.length > 0  && visible && (user.roles_id < 3 || (currentMonthAchievers === true ? dashboardList.currentMonthOffer :  dashboardList.offer)) && (
                            <Typography variant="h6" sx={{ color: "#2665AD", fontWeight: "bold" }}>{
                                targetPercentage === 1 ? `Congratulations To Our ${currentMonth} Enrollment Target and Commission Bonus Achievers!`
                                    : `Leaders Over ${targetPercentage === 0.501 ? '50' : '75'}% Of Goal To Earn Themselves Extra Commission On Every Active Member In ${currentMonth}!`
                            }
                                <div className="congratulation-line"></div>
                            </Typography>
                        )}
                        </Grid>
                        {companyLogoSlider?.length > 0 && (user.roles_id < 3 || (currentMonthAchievers === true ? dashboardList.currentMonthOffer :  dashboardList.offer)) && (
                            <Grid item lg={2} md={2} sm={12} xs={12} sx={{ textAlign: "right" }} mb={1}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={visible ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                                    onClick={() => setVisible((prev) => !prev)}
                                >
                                    {visible ? "Hide achievers" : "View achievers"}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                    {visible && companyLogoSlider.length > 0 && (user.roles_id < 3 || (currentMonthAchievers === true ? dashboardList.currentMonthOffer :  dashboardList.offer)) && (
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
                            <div className="marquee-container marquee-achievers" >
                                <Marquee
                                    duration={companyLogoSlider.length * 2500}
                                    delay={0}
                                    pauseOnHover
                                    reverse={true}
                                    style={{ width: "100%" }}>
                                    {companyLogoSlider.map((item, index) => (
                                        <Tooltip key={index} title={<Typography level="h4">{item.companyDetails ? item.companyDetails.company_name : ''}</Typography>} arrow>
                                            <div className="marquee-card" style={{ width: targetPercentage === 1 ? '10vw' : '14vw', height: targetPercentage === 1 ? '4vw' : '4.1vw' }} >
                                                <Grid container item lg={12} md={12} sm={12} xs={12} pt={0} spacing={1} sx={{ textWrap: 'initial', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                    {item.companyDetails ? item.companyDetails.company_logo_url ? (
                                                        <>
                                                            {
                                                                targetPercentage === 1 ?
                                                                    <>
                                                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                                                            <img
                                                                                style={{ width: '-webkit-fill-available' }}
                                                                                src={`${config.BACKEND_URL}images/companyLogo/${item.companyDetails ? item.companyDetails.company_logo_url : ''}`}
                                                                                alt="companyLogo"
                                                                                onContextMenu={(e) => isMobile && e.preventDefault()}
                                                                            />
                                                                        </Grid>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                                                            <img
                                                                                style={{ width: '-webkit-fill-available' }}
                                                                                src={`${config.BACKEND_URL}images/companyLogo/${item.companyDetails ? item.companyDetails.company_logo_url : ''}`}
                                                                                alt="companyLogo"
                                                                                onContextMenu={(e) => isMobile && e.preventDefault()}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                                                            <div style={{ width: '83%', height: 'auto' }} className='circularprogress-text mobile-width-progress'>
                                                                                <CircularProgressbarWithChildren
                                                                                    value={item.percentage}
                                                                                    styles={buildStyles({
                                                                                        // rotation: 0.90,
                                                                                        strokeLinecap: 'butt',
                                                                                        strokeWidth: "9",
                                                                                        pathTransitionDuration: 0.5,
                                                                                        pathColor: `rgba(40, 105, 180, 1), ${item.percentage / 100})`,
                                                                                        textColor: 'black',
                                                                                        trailColor: '#d6d6d6',
                                                                                        backgroundColor: '#3e98c7',
                                                                                    })}
                                                                                >
                                                                                    <div className="circular-text-background">
                                                                                        {`${item.percentage >= 100 ? '100' : Math.ceil(item.percentage)}%`}
                                                                                    </div>
                                                                                    <RadialSeparators
                                                                                        count={10}
                                                                                        style={{
                                                                                            background: "#fff",
                                                                                            width: "2px",
                                                                                            height: `${10}%`
                                                                                        }}
                                                                                    />
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                        </Grid>
                                                                    </>
                                                            }

                                                        </>

                                                    ) : (
                                                        targetPercentage === 1 ?
                                                            <>
                                                                <Grid item lg={12} md={12} sm={12} xs={12} sx={{ margin: 'auto' }}>
                                                                    <Typography sx={{ fontSize: '0.8rem', textAlign: 'center' }} className='achievers-company-name'>{item.companyDetails ? item.companyDetails.company_name : ''}</Typography>
                                                                </Grid>
                                                            </>
                                                            :
                                                            <>
                                                                <Grid item lg={8} md={8} sm={8} xs={8} sx={{ margin: 'auto' }}>
                                                                    <Typography sx={{ fontSize: '0.8rem', textAlign: 'center' }} className='achievers-company-name'>{item.companyDetails ? item.companyDetails.company_name : ''}</Typography>
                                                                </Grid>
                                                                <Grid item lg={4} md={4} sm={4} xs={4} sx={{ margin: 'auto', paddingLeft: '2px' }}>
                                                                    <div style={{ width: '83%', height: 'auto' }} className='circularprogress-text mobile-width-progress'>
                                                                        <CircularProgressbarWithChildren
                                                                            value={item.percentage}
                                                                            styles={buildStyles({
                                                                                // rotation: 0.90,
                                                                                strokeLinecap: 'butt',
                                                                                // strokeWidth: "9",
                                                                                pathTransitionDuration: 0.5,
                                                                                pathColor: `rgba(40, 105, 180, 1), ${item.percentage / 100})`,
                                                                                textColor: 'black',
                                                                                trailColor: '#d6d6d6',
                                                                                backgroundColor: '#3e98c7',
                                                                            })}
                                                                        >
                                                                            <div className="circular-text-background">
                                                                                {`${item.percentage >= 100 ? '100' : Math.ceil(item.percentage)}%`}
                                                                            </div>
                                                                            <RadialSeparators
                                                                                count={10}
                                                                                style={{
                                                                                    background: "#fff",
                                                                                    width: "2px",
                                                                                    height: `${10}%`
                                                                                }}
                                                                            />
                                                                        </CircularProgressbarWithChildren>
                                                                    </div>
                                                                </Grid>
                                                            </>
                                                    )
                                                        :
                                                        null}
                                                </Grid>
                                            </div>
                                        </Tooltip>
                                    ))}
                                </Marquee>
                            </div>
                        </Grid>
                    )}
                    {currentMonthOffer && user.roles_id === 3 &&
                         <Grid container item lg={12} md={12} sm={12} xs={12} mb={2}>
                          <Card sx={{ width:"100%", margin: "auto", position: "relative" , backgroundSize: "cover", backgroundPosition: "center",}}>
                             {slides[currentSlide]}
                            <div>
                                <button
                                onClick={prevSlide}
                                style={{
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                transform: "translateY(-50%)",
                                fontSize: 15,
                                backgroundColor: "none",
                                color: "black",
                                border: "none",
                                padding: 10,
                                cursor: "pointer",
                                }}
                            >
                                &#10094;
                                </button>
                                <button
                                    onClick={nextSlide}
                                    style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: 0,
                                    transform: "translateY(-50%)",
                                    fontSize: 15,
                                    backgroundColor: "none",
                                    color: "black",
                                    border: "none",
                                    padding: 10,
                                    cursor: "pointer",
                                    }}
                                >
                                    &#10095;
                                </button>
                            </div>
                        </Card>
                     </Grid>
                     } 
                    {user.roles_id < 3 ?
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} alignItems="center">
                            <Grid item lg={3} md={3} sm={12} xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "1px solid #2C1A95",
                                        borderRadius: "12px",
                                        padding: "10px 16px",
                                        width: "270px",
                                        position: "relative",
                                    }}
                                >
                                <Box sx={{ display: "flex", alignItems: "center", }}>
                                    {
                                        dashboardList
                                            ?
                                            companylogo
                                                ?
                                                <img className="dashlogo" style={{ height: isMobile ? "100%" : "90px" }} src={config.BACKEND_URL + "images/companyLogo/" + companylogo} alt="company_logo" />
                                                :
                                                <img className="dashlogo" style={{ height: isMobile ? "100%" : "90px" }} src={require("../../../assets/images/uploadLogo.png")} alt="upload_logo" />
                                            :
                                            <img className="dashlogo" style={{ height: isMobile ? "100%" : "90px" }} src={require("../../../assets/images/uploadLogo.png")} alt="upload_logo2" />
                                    }
                                </Box>
                                {/* {user.roles_id <= 3 ?
                                    <IconButton variant='contained' size='medium' color='primary'  sx={{
                                        position: "absolute",
                                        right: "-12px",
                                        bottom: "-12px",
                                        backgroundColor: "white",
                                        border: "1px solid #2C1A95",
                                        borderRadius: "50%",
                                        color: "#2C1A95",
                                        "&:hover": { backgroundColor: "#f3f3ff" },
                                    }}
                                        onClick={(e) => { setUploadLogo(true) }}
                                    >
                                        {companylogo ? <EditOutlinedIcon/> : <UploadOutlinedIcon/>}
                                    </IconButton>
                                    : null} */}

                                </Box>
                            </Grid>
                            <Grid item lg={3} md={3} sm={12} xs={12} sx={{ display: "flex", placeSelf: "flex-end" }}>
                                <Autocomplete
                                    fullWidth
                                    onChange={handleInputChange}
                                    options={companies ? companies : ''}
                                    groupBy={(option) => option.firstLetter}

                                    getOptionLabel={(option) => option.company_name || ""}
                                    value={selectedValue}
                                    filterOptions={(options, { inputValue }) => {
                                        const filteredOptions = options.filter((option) => {
                                            const labelForSearch = `${option.company_name} ${option.aidList.join(" ")}`.toLowerCase();
                                            return labelForSearch.includes(inputValue.toLowerCase());
                                        });
                                        return filteredOptions;
                                    }}

                                    renderOption={(props, option) =>
                                        <li {...props} className='dropDown-list'>
                                            <div className='cursor-pointer display_block' style={{ backgroundColor: "#e5effb" }}>
                                                {option.company_name}
                                            </div>
                                            {option.aidList.length > 0 && `${option.aidList.join(", ")}`}
                                        </li>
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} label="Company List" size='small' margin='dense' fullWidth />
                                    )}
                                />

                            </Grid>

                            <Grid item lg={3} md={3} sm={12} xs={12} sx={{ display: "flex", placeSelf: "flex-end" }}>
                                <FormControl fullWidth size="small" margin='dense'>
                                    <InputLabel id="mutiple-select-label">Select AID</InputLabel>
                                    <Select
                                        labelId="mutiple-select-label"
                                        multiple
                                        label="Select AID"
                                        options={[{ label: "All", value: "*" }, ...options]}
                                        value={selected}
                                        onChange={(e) => { handleChange1(e) }}
                                        renderValue={(selected) => selected.join(", ")}
                                        MenuProps={MenuProps}>
                                        <MenuItem
                                            value="all"
                                            classes={{
                                                root: isAllSelected ? classes.selectedAll : ""
                                            }}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    classes={{ indeterminate: classes.indeterminateColor }}
                                                    checked={isAllSelected}
                                                    indeterminate={
                                                        selected.length > 0 && selected.length < AidList.length
                                                    } />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.selectAllText }}
                                                primary="Select All"
                                            />
                                        </MenuItem>
                                        {AidList.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <ListItemIcon>
                                                    <Checkbox checked={selected.indexOf(option) > -1} />
                                                </ListItemIcon>
                                                <ListItemText primary={option} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>


                            <Grid item lg={3} md={3} sm={12} xs={12} sx={{ display: "flex", placeSelf: "flex-end",paddingBottom:"8px !important" }}>
                                <Button variant='contained' color='primary' size="medium" fullWidth sx={{ fontWeight: "bold" }} onClick={(e) => { handleAffiliateLogin() }}>Login As An Affiliate</Button>
                            </Grid>

                        </Grid>
                        : null}

                    {user.roles_id === 3 ?
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1} alignItems="stretch">
                            {/* <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
                                <Card className="dashbordCard" >
                                    <CardContent sx={{padding:"5px !important"}}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={0.3} className={isMobile?"bonus-backMobile":'bonus-back'}  sx={{ display: "flex", flexWrap: "wrap", alignItems: "center",flexGrow: 1 }} >
                                                <Grid item lg={3} md={3} sm={12} xs={12} sx={{ flexGrow: 1 }}>
                                                    {isMobile?
                                                        <img src={require("../../../assets/images/dollerSignMobile.png")} alt="FundingImage" style={{width:"20%",height:"auto",display:"block",marginLeft:"auto",marginRight:"auto"}} />
                                                        :
                                                        <img src={require("../../../assets/images/dollerSignImage.png")} alt="FundingImage" style={{width:"117%",height:"auto"}} />
                                                        }
                                                </Grid>
                                                <Grid item lg={9} md={9} sm={12} xs={12} p={2} sx={{ flexGrow: 1 }}>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} justifyContent={isMobile?"center":"left"}>
                                                    <Typography variant={isMobile?'h5':'h6'} textAlign={isMobile?"center":"left"} fontWeight={"bolder"} color={"#FFB11F"}>Unlock More With Funding Snapshot</Typography>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
                                                        <img src={require("../../../assets/images/fundingShotWhite.png")} alt="FundingImage" style={{width:isMobile?"50%":"60%",height:"auto",display:"block",marginLeft:isMobile?"auto":"0px",marginRight:isMobile?"auto":"0px"}}/>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                                        <Typography variant={isMobile?'h6':'body1'}  textAlign={isMobile?"center":"left"} fontWeight={500} color={"#FFFFFF"}>Use Funding Snapshot To Guide Your Clients To The Right Funding — And Grow Your Commissions!"</Typography>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2} mb={1} textAlign={isMobile?"center":"left"}>
                                                        <Button 
                                                        onClick={() => window.open('https://www.youtube.com/watch?v=ZKPsII-mYLc&t=1s', '_blank')}
                                                            sx={{
                                                            backgroundColor:"#FFB11F",
                                                            color:"black",
                                                            borderRadius:"6px",
                                                            fontWeight:700,
                                                            minWidth:200,
                                                            fontSize:"20px", 
                                                            '&:hover': {
                                                            backgroundColor: "#FFB11F", // same as normal
                                                            color: "black",             // same as normal
                                                            }}}>LEARN MORE</Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    </CardContent>
                                </Card>
                            </Grid> */}
                            {currentMonthOffer && user.roles_id === 3 ?
                                <>
                                <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
                                    <Card className="dashbordCard" >
                                        <CardOverflow>
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <Typography variant={isMobile?"body1":'h6'} fontWeight="bold" textAlign="center">
                                                    Commission Bonus Promo {dashboardList.currentOfferMonth ? dashboardList.currentOfferMonth : ''}
                                                </Typography>
                                            </Grid>
                                        </CardOverflow>
                                        <CardContent sx={{padding:"5px !important"}}>
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <Grid container item className={isMobile?"bonus-backMobile":"bonus-back"} sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", }} >
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                        <Typography color={'#171254'} variant={isMobile?"body1":"h6"} className='animation-dash' sx={{ marginTop:isMobile?"0%": "1%", color: " #171254", textAlign: "center" }}><b>{dashboardList.pendingDays} {parseInt(dashboardList.pendingDays) <= 1 ? "DAY" : "DAYS"}  TO GO</b></Typography>
                                                    </Grid>
                                                    <Stack direction="row" style={{ width: "100%" }}>
                                                        <Grid item lg={4} md={4} sm={12} xs={12} sx={{ flexGrow: 1 }}>
                                                           
                                                            <Grid container justifyContent="center" alignItems="center" mt={1} mb={2}>
                                                                <Grid item className='squarenew' p={isMobile?"8px":2}>
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Typography sx={{ fontSize:isMobile?"10px": "15px", color: "black" }}><b>CURRENT</b>
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" ,marginTop: newTarget != currentMonthOffer.target_active_enrollments ? '25px': '0px'}}>
                                                                        <Typography sx={{ fontSize:isMobile?"10px": "15px", color: "black" }}>
                                                                            <b style={{ color: membersActiveCount>=newTarget?"1B8B30":'#E23030', fontSize: isMobile? '15px':'2.5rem' }} >{membersActiveCount}</b>
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Typography sx={{ fontSize:isMobile?"10px": "15px", color: "black" }}>Net Actives<br />As of {Moment(currentDate).format('MM-DD-YYYY')}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item lg={8} md={8} sm={12} xs={12} className='slider-containerBack' sx={{ flexGrow: 1, marginTop: "10px" }}>
                                                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                <Typography color={'black'} sx={{ fontSize: isMobile ? "7px": "15px",textAlign:'center' }}> <b>Slide To Set Your Desired Bonus</b></Typography>
                                                            </Grid>
                                                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center", }}>
                                                                <Typography color={'black'} sx={{ fontSize: isMobile ? "10px": "19px" }}><b><span><s>${currentMonthCommission} </s></span><span style={{ fontSize: isMobile?"13px":"25px" }}>/${currentMonthCommissionUpdated}</span></b></Typography>
                                                            </Grid>
                                                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                <Typography color={'#1F1694'} sx={{ fontSize:isMobile?"13px":"29px" }}><b> EXTRA {currencyFormat(parseFloat(sliderValue))}</b></Typography>
                                                            </Grid>
                                                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                <div className={`${Sliderclasses.root} slidingTarget`}>
                                                                    <Slider
                                                                        value={sliderValue}
                                                                        onChange={handleSliderChange}
                                                                        aria-labelledby="continuous-slider"
                                                                        step={10}
                                                                        marks={marks}
                                                                        min={minTarget}
                                                                        max={maxTarget}
                                                                        sx={{
                                                                            color: "black", // Default slider color
                                                                            "& .MuiSlider-track": {
                                                                                height: "4px !important",
                                                                                backgroundColor: "#1F1694 !important", // Change color of track up to the runner
                                                                                borderColor: "#1F1694 !important",
                                                                            },
                                                                            "& .MuiSlider-rail": {
                                                                                backgroundColor: "#BAB9B9 !important", // Default color before slider moves
                                                                                height:"4px !important"
                                                                            },
                                                                            "& .MuiSlider-thumb": {
                                                                                backgroundColor: "#1F1694 !important", // Change thumb color
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                <Stack direction="row" spacing={2}>
                                                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                                                        <img src={require("../../../assets/images/GiftBoxing1.png")} alt="giftboxing" style={{width:isMobile?"20px":"auto"}}/>
                                                                    </Grid>
                                                                    <Grid item lg={9} md={9} sm={12} xs={12}>
                                                                        <Button variant="contained" sx={{ minWidth:isMobile? 30 : 80, maxWidth: isMobile ? 50 :100, backgroundColor: "#000211", color: "white",fontSize:isMobile?"10px":"15px", fontWeight: isMobile?"normal":"bold",'&:hover': {
                                                                            backgroundColor: "#000211",color: "white", 
                                                                            }, }} onClick={saveNewTarget}>Save</Button>
                                                                    </Grid>
                                                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                                                        <img src={require("../../../assets/images/GiftBoxing1.png")} alt="giftboxing"  style={{width:isMobile?"20px":"auto"}}/>
                                                                    </Grid>
                                                                </Stack>

                                                            </Grid>
                                                           
                                                        </Grid>
                                                        <Grid item lg={4} md={4} sm={12} xs={12} sx={{ flexGrow: 1, }}>
                                                            <Grid container justifyContent="center" alignItems="center" mt={1} mb={2}>
                                                                
                                                                <Grid item className='squarenew' p={isMobile?"8px":2}>
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }} >
                                                                        <Typography color={'black'} sx={{ fontSize: isMobile?"10px":"15px" }}><b>TARGET</b></Typography>
                                                                    </Grid>
                                                                    {
                                                                        newTarget != currentMonthOffer.target_active_enrollments ?
                                                                        <>
                                                                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }} >
                                                                            <Typography sx={{ fontSize: "15px", color: '#1B8B30' }}><b style={{ color: '#1B8B30', fontSize: isMobile? '12px':'16px' }}><s>{currentMonthOffer.target_active_enrollments}</s></b></Typography>
                                                                        </Grid>
                                                                        </>
                                                                        : ''
                                                                    }
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }} >
                                                                        <Typography sx={{ fontSize: "15px", color: '#1B8B30' }}><b style={{ color: '#1B8B30', fontSize: isMobile? '15px':'2.5rem' }}>{newTarget}</b></Typography>
                                                                    </Grid>
                                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Typography sx={{ fontSize:isMobile?"10px": "15px", color: "black" }}>Net Actives<br />As of {Moment(lastDay).format('MM-DD-YYYY')}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>
                                                    </Stack>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={1}>
                                                        <Box sx={{backgroundColor:"white"}}>
                                                            {
                                                                targetStatus == 'Above' ?
                                                                    <><Typography sx={{ fontSize: isMobile ? "10px": "15px", color: "black", textAlign: "center" ,fontWeight:400}}><b>YAY! YOU ARE ON YOUR WAY TO GET<br /> <span style={{ color: "#4D6D51", fontSize: isMobile?"13px":"15px",fontWeight:"bold" }}>EXTRA {currencyFormat(parseFloat(sliderValue))}</span></b></Typography></>
                                                                    : <><Typography sx={{ fontSize: isMobile ? "10px": "15px", color: "black", textAlign: "center",fontWeight:400 }}><b>You are Only <span style={{ color: "black", fontSize: isMobile?"13px":"20px",fontWeight:"bold" }}> {targetDiff} Away</span></b></Typography></>
                                                            }
                                                            </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                </>
                                :
                                <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
                                {/* <Card className="dashbordCard" >
                                    <CardContent sx={{padding:"5px !important"}}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={0.3} className={isMobile?"funding-backMobile":'funding-back'}  sx={{ display: "flex", flexWrap: "wrap", alignItems: "center",flexGrow: 1 }} >
                                                <Grid item lg={3} md={3} sm={12} xs={12} sx={{ flexGrow: 1 }}>
                                                    {isMobile?
                                                        <img src={require("../../../assets/images/dollerSignMobile.png")} alt="FundingImage" style={{width:"20%",height:"auto",display:"block",marginLeft:"auto",marginRight:"auto"}} />
                                                        :
                                                        <img src={require("../../../assets/images/dollerSignImage.png")} alt="FundingImage" style={{width:"117%",height:"auto"}} />
                                                        }
                                                </Grid>
                                                <Grid item lg={9} md={9} sm={12} xs={12} p={2} sx={{ flexGrow: 1 }}>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} justifyContent={isMobile?"center":"left"}>
                                                    <Typography variant={isMobile?'h5':'h6'} textAlign={isMobile?"center":"left"} fontWeight={"bolder"} color={"#FFB11F"}>Unlock More With Funding Snapshot</Typography>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
                                                        <img src={require("../../../assets/images/fundingShotWhite.png")} alt="FundingImage" style={{width:isMobile?"50%":"60%",height:"auto",display:"block",marginLeft:isMobile?"auto":"0px",marginRight:isMobile?"auto":"0px"}}/>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                                        <Typography variant={isMobile?'h6':'body1'}  textAlign={isMobile?"center":"left"} fontWeight={500} color={"#FFFFFF"}>Use Funding Snapshot To Guide Your Clients To The Right Funding — And Grow Your Commissions!"</Typography>
                                                    </Grid>
                                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2} mb={1} textAlign={isMobile?"center":"left"}>
                                                        <Button 
                                                        onClick={() => window.open('https://www.youtube.com/watch?v=ZKPsII-mYLc&t=1s', '_blank')}
                                                            sx={{
                                                            backgroundColor:"#FFB11F",
                                                            color:"black",
                                                            borderRadius:"6px",
                                                            fontWeight:700,
                                                            minWidth:200,
                                                            fontSize:"20px", 
                                                            '&:hover': {
                                                            backgroundColor: "#FFB11F", // same as normal
                                                            color: "black",             // same as normal
                                                            }}}>LEARN MORE</Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    </CardContent>
                                </Card> */}
                                   <Grid container item lg={12} md={12} sm={12} xs={12} mb={2}>
                                        <Card sx={{ width:"100%", margin: "auto", position: "relative" , backgroundSize: "cover", backgroundPosition: "center",}}>
                                            {fundingSlides[fudingCurrentSlide]}
                                            <div>
                                                <button
                                                onClick={fundingPrevSlide}
                                                style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: 0,
                                                transform: "translateY(-50%)",
                                                fontSize: 15,
                                                backgroundColor: "none",
                                                color: "black",
                                                border: "none",
                                                padding: 10,
                                                cursor: "pointer",
                                                }}
                                            >
                                                &#10094;
                                                </button>
                                                <button
                                                    onClick={fundingNextSlide}
                                                    style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: 0,
                                                    transform: "translateY(-50%)",
                                                    fontSize: 15,
                                                    backgroundColor: "none",
                                                    color: "black",
                                                    border: "none",
                                                    padding: 10,
                                                    cursor: "pointer",
                                                    }}
                                                >
                                                    &#10095;
                                                </button>
                                            </div>
                                        </Card>
                                    </Grid>
                                </Grid>
                            }

                            <Grid item lg={ user.roles_id === 3 ? 3 : 6}
                                         md={user.roles_id === 3 ? 3 : 6} 
                                    sm={12} xs={12} sx={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
                                <Card className="dashbordCard" >
                                    <CardOverflow>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant='h6' fontWeight="bold" textAlign="center">
                                                What’s New?
                                            </Typography>
                                        </Grid>
                                    </CardOverflow>
                                    <CardContent sx={{padding:"5px !important"}}>
                                        <Grid item lg={12} md={12} sm={12} xs={12} >

                                            <Box sx={{
                                                // backgroundColor: "#D9D9D9",
                                                width: "100%",
                                               
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                 height:  user.roles_id === 3 ? "233px" : "200px"

                                            }}>
                                                <iframe
                                                    width="100%"
                                                    height="100%"
                                                    src="https://www.youtube.com/embed/D7DVhbwOqhI?si=mYIxe-_DavGH_Hs-"
                                                    title="YouTube video player"
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                ></iframe>
                                            </Box>

                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                          
                            <Grid item  lg={user.roles_id === 3 ? 3 : 6}
                                         md={ user.roles_id === 3 ? 3 : 6} 
                                          sm={12} xs={12} sx={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
                                <Card className="dashbordCard" >
                                    <CardOverflow>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant="h6" fontWeight="bold" textAlign="center">
                                                Explore
                                            </Typography>
                                        </Grid>
                                    </CardOverflow>
                                    <CardContent sx={{padding:"5px !important"}}>
                                        {
                                            dashboardList.applicableToMediaServices ?
                                                <Grid item lg={12} md={12} sm={12} xs={12} alignItems="center" >
                                                    <a href={config.BASE_URL + 'mediaservices'}><img src={require("../../../assets/images/avail-media-services.png")} alt="Facebook" style={{width:"100%"}}/></a>
                                                </Grid>
                                            : ''
                                        }
                                        <Card className="explore" sx={{ color: "white", mt:dashboardList.applicableToMediaServices ?0 : 2, p: dashboardList.applicableToMediaServices ?"2px": "14px" }} onClick={() => window.open("https://www.facebook.com/groups/myfreescorenow", "_blank")}>
                                            <Grid container lg={12} md={12} sm={12} xs={12} alignItems="center" >
                                                {/* Facebook Logo & Name */}
                                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} alignItems="center" justifyContent="center" >
                                                        <img src={require("../../../assets/images/facebook-dash.png")} alt="Facebook" width={dashboardList.applicableToMediaServices ?"35":"40"} height={dashboardList.applicableToMediaServices ?"35":"40"} />
                                                    </Grid>
                                                   
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} alignItems="center" justifyContent="center">
                                                        <Typography fontWeight="bold">Facebook</Typography>
                                                    </Grid>
                                                </Grid>
                                                {/* Divider */}
                                                <Divider orientation="vertical" flexItem sx={{ mr: "-1px",backgroundColor:"white", display: { xs: 'block', sm: 'block',md: 'block',lg:'block',xl:'block' } }} />
                                                {/* MyFreeScoreNow Logo & Text */}
                                                <Grid item lg={7} md={7} sm={7} xs={7} display="flex" flexDirection="column" alignItems="center">
                                                    <img src={require("../../../assets/images/myfreescorenow-Logo.png")} alt="Logo" width="80" />
                                                    <Typography variant="body1"  fontWeight="bold" sx={{ textAlign: "center", mt: 1 }}>
                                                        Join Our Group
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                        
                                        <Card className="explore" sx={{ color: "white", mt: dashboardList.applicableToMediaServices ?1 : 2, p:dashboardList.applicableToMediaServices ?"2px":"14px" }} onClick={() => window.open("https://www.youtube.com/@MyFreeScoreNow", "_blank")}>
                                            <Grid container alignItems="center" >
                                                {/* YouTube Logo & Name */}
                                                <Grid item lg={4} md={4} sm={4} xs={4} >
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} alignItems="center" justifyContent="center" >
                                                        <img src={require("../../../assets/images/youtubeSnap.png")} alt="YouTube" width={dashboardList.applicableToMediaServices ?"25":"30"} height={dashboardList.applicableToMediaServices ?"25":"30"} />
                                                    </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} alignItems="center" justifyContent="center">
                                                        <Typography fontWeight="bold">YouTube</Typography>
                                                    </Grid>
                                                </Grid>

                                                {/* Divider */}
                                                <Divider orientation="vertical" flexItem sx={{ mr: "-1px",backgroundColor:"white", display: { xs: 'block', sm: 'block',md: 'block',lg:'block',xl:'block' } }} />

                                                {/* MyFreeScoreNow Logo & Text */}
                                                <Grid item lg={7} md={7} sm={7} xs={7} display="flex" flexDirection="column" alignItems="center" margin="auto">
                                                    <img src={require("../../../assets/images/myfreescorenow-Logo.png")} alt="Logo" width="80" />
                                                    <Typography variant="body1"  fontWeight="bold" sx={{ textAlign: "center", mt: 1 }}>
                                                        Affiliate Program Benefits
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </CardContent>
                                </Card>
                            </Grid>
                            
                            
                        </Grid>
                        : null}
                    <Grid container spacing={2} mt={1} sx={{display:"flex",justifyContent:"center"}}>
                        { user.roles_id === 1 || user.roles_id === 2 || user.roles_id === 3 ?
                        <Grid item xs={12} sm={12} md={4} lg={2.4}>
                            <Typography className="font16" fontWeight="bold" >Commissions (LT: {dashboardList.totalCommissionPaid ? currencyFormat(parseFloat(dashboardList.totalCommissionPaid),0) : 0})</Typography>
                            <Card className="commisson-card" sx={{ height: "250px", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
                                <Typography className='font14'>Projected ({dashboardList.lastCommitionStartDate ? dashboardList.lastCommitionStartDate : ''})</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.lastMonthCommission
                                    ? currencyFormat(parseFloat(dashboardList.lastMonthCommission))
                                    : '$0.00'}</Typography>
                                <Typography className='font14'>Last {((dashboardList.balance) && dashboardList.balance > 0) ? 'Approved' : 'Paid'} ({dashboardList.lastApprovedMonth ? dashboardList.lastApprovedMonth : ''})</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.lastApprovedCommission
                                    ? currencyFormat(parseFloat(dashboardList.lastApprovedCommission))
                                    : '$0.00'}</Typography>
                                <Typography className='font14'>Percentage Change</Typography>
                                <Typography className="font16" fontWeight="bold" style={{ color: dashboardList.commissionPercentage > 0 ? "green" : "red",marginTop:isMobile?"-20px":"-30px" }} >{dashboardList.commissionPercentage ? (dashboardList.commissionPercentage).toFixed(2) : '0'}%</Typography>
                            </Card>
                        </Grid>
                        :""
                        }   
                        <Grid item xs={12} sm={12} md={4} lg={2.4}>
                            <Typography className="font16" fontWeight="bold">Enrollments ({dashboardList.totalEnrollment ? dashboardList.totalEnrollment : '0'})</Typography>
                            <Card className="enrollment-card" sx={{ height: "250px", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
                                <Typography className='font14'>Month To Date (MTD)</Typography>
                                <Typography className="font16" fontWeight="bold"  sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.enrollTillDateThisMonth ? dashboardList.enrollTillDateThisMonth : '0'}</Typography>
                                <Typography className='font14'>Last Month</Typography>
                                <Typography className="font16" fontWeight="bold"  sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.lastEnroll ? dashboardList.lastEnroll : '0'}</Typography>
                                <Typography className='font14'>Current Actives</Typography>
                                <Typography className="font16" fontWeight="bold"  sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.totalActiveEnrollment ? dashboardList.totalActiveEnrollment : '0'}</Typography>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={2.4}>
                            <Typography className="font16" fontWeight="bold">Retention</Typography>
                            <Card className="commisson-card" sx={{ height: "250px", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
                                <Typography className='font14'>New Clients ({dashboardList.retentionMonth ? dashboardList.retentionMonth : ''})</Typography>
                                <Typography className="font16" sx={{ color:"green", marginTop:isMobile?"-20px":"-30px"}}> <span style={{ fontWeight: 300, fontSize: "14px" }}>{dashboardList.AIDTotal ? (dashboardList.AIDTotal) : 0} </span></Typography>
                                <Typography className='font14'>{dashboardList.retentionMonth ? dashboardList.retentionMonth : ''} Actives As On {dashboardList.refDate ? dashboardList.refDate : ''}</Typography>
                                <Typography className="font16" fontWeight="bold" style={{ color: (dashboardList.retentionForPreviousMonth ? ((dashboardList.retentionForPreviousMonth).includes("Above") ? "green" : "red") : '') ,marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.AIDRetained ? (dashboardList.AIDRetained) : 0} <span style={{ fontWeight: 300, fontSize: "15px" }}> ({retentionData ? (retentionData > 0 ? (retentionData ) : retentionData) : 0}%)</span></Typography>
                                <Typography className='font14'>Target Retention Rate</Typography>
                                <Typography className="font16" fontWeight="bold" style={{marginTop:isMobile?"-20px":"-30px" }}>65% <span style={{ fontWeight: 300, fontSize: "15px",color: (dashboardList.retentionForPreviousMonth ? ((dashboardList.retentionForPreviousMonth).includes("Above") ? "green" : "red") : '') }}> {dashboardList.retentionForPreviousMonth ? dashboardList.retentionForPreviousMonth : ''}</span></Typography>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={2.4}>
                            <Typography className="font16" fontWeight="bold">Referrals ({dashboardList.allTotalReferralCount ? dashboardList.allTotalReferralCount : '0'})</Typography>
                            <Card className="enrollment-card" sx={{ height: "250px", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
                                <Typography className='font14'>Month To Date (MTD)</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.referralTillDate ? dashboardList.referralTillDate : '0'}</Typography>
                                <Typography className='font14'>Referred Enrollment</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.referralEnrollments ? dashboardList.referralEnrollments : '0'}</Typography>
                                <Typography className='font14'>Commission (Referral + Bonus)</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{ marginTop: isMobile ? "-20px" : "-30px", position: 'relative', display: 'inline-block' }}>{dashboardList.totalReferralInitialCommission ? '$' + (dashboardList.totalReferralInitialCommission).toFixed(2) : '$0'} <span style={{fontSize: '10px',fontWeight: 'normal',display: 'inline-flex', alignItems: 'center', gap: '2px'}}><span style={{ verticalAlign: 'super' }}>({dashboardList.lastApprovedMonth ? dashboardList.lastApprovedMonth : ''})</span>
                                    <span style={{ verticalAlign: 'sub' }}>({dashboardList.totalReferralCommission ? dashboardList.totalReferralCommission : 0} + {dashboardList.totalReferralBonus ? dashboardList.totalReferralBonus : 0})</span></span></Typography>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={2.4}>
                            <Typography className="font16" fontWeight="bold">Leads ({dashboardList.allTotalLeadCount ? dashboardList.allTotalLeadCount : '0'})</Typography>
                            <Card className="commisson-card" sx={{ height: "250px", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
                                <Typography className='font14'>Month To Date (MTD)</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.leadTillDate ? dashboardList.leadTillDate : '0'}</Typography>
                                <Typography className='font14'>Last Month</Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.lastLead ? dashboardList.lastLead : '0'}</Typography>
                                <Typography className='font14'>Converted To Paid(YTD) </Typography>
                                <Typography className="font16" fontWeight="bold" sx={{marginTop:isMobile?"-20px":"-30px"}}>{dashboardList.leadUpgraded ? dashboardList.leadUpgraded : '0'}</Typography>
                            </Card>
                        </Grid>
                    </Grid>
                    {user.roles_id == 3 && (
                        (dashboardList.MemberRetentionData > 0 || dashboardList.suspendedActionCount > 0 || dashboardList.abandanCount > 0) && (                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={3}>
                            <Card className='potential-card'>
                                <CardContent>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={3} sx={{ justifyContent: "center" }}>
                                        {dashboardList.MemberRetentionData > 0 ?
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Card sx={{
                                                    p: 2,
                                                    boxShadow: 3,
                                                    borderRadius: 2,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    minHeight: "150px",
                                                    justifyContent: "space-between",
                                                }}>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={3} alignItems="center">
                                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                                            <Typography className='font14'>
                                                                <span  className='seeList'><img src={require("../../../assets/icons/sideBarIcons/ActionRequird.png")} alt="action-require" width="20" height="20" /> 
                                                                {dashboardList.MemberRetentionData}</span>
                                                              
                                                                Clients Want Their Accounts To Be Cancelled.</Typography>
                                                        </Grid>
                                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                                            <Typography className='font14'><span  className='seeList'>{(dashboardList.memberRetentionCommission ? currencyFormat(parseFloat(dashboardList.memberRetentionCommission)) : '$0.00')} </span>
                                                            Potential Loss/Year</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} >
                                                        <Button variant='contained' color="primary"  sx={{fontWeight:"bold"}} fullWidth onClick={() => window.open(`/pendingclosepanel/pending?companyId==${companyId}`, "_blank")}>SEE LIST </Button>
                                                    </Grid>
                                                </Card>
                                            </Grid>
                                            : null}
                                        {dashboardList.suspendedActionCount > 0 ?
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Card sx={{
                                                    p: 2,
                                                    boxShadow: 3,
                                                    borderRadius: 2,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    minHeight: "150px",
                                                    justifyContent: "space-between",
                                                }}>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={3} alignItems="center">
                                                        <Grid item lg={6} md={6} sm={6} xs={6} > 
                                                            <Typography className='font14'><span className='seeList'><img src={require("../../../assets/icons/sideBarIcons/ActionRequird.png")} alt="action-require" width="20" height="20" /> {dashboardList.suspendedActionCount}</span>
                                                                Clients Currently In Suspended State.</Typography>
                                                        </Grid>
                                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                                            <Typography className='font14'><span className='seeList'>{(dashboardList.suspendedMemberCommission ? currencyFormat(parseFloat(dashboardList.suspendedMemberCommission)) : '$0.00')} </span>
                                                            Potential Loss/year</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} >
                                                        <Button variant='contained' color="primary" sx={{fontWeight:"bold"}}  fullWidth onClick={() => window.open(`/suspendedMemberList?companyId=${companyId}`, "_blank")} >SEE LIST </Button>
                                                    </Grid>
                                                </Card>
                                            </Grid>
                                            : null}
                                        {dashboardList.abandanCount > 0 ?
                                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                                <Card sx={{
                                                    p: 2,
                                                    boxShadow: 3,
                                                    borderRadius: 2,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    width: "100%",
                                                    minHeight: "150px",
                                                    justifyContent: "space-between",
                                                }}>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={3} alignItems="center">
                                                            <Grid item lg={6} md={6} sm={6} xs={6} > 
                                                               <Typography className='font14'><span  className='seeList'><img src={require("../../../assets/icons/sideBarIcons/ActionRequird.png")} alt="action-require" width="20" height="20" /> 
                                                                {dashboardList.abandanCount}</span>
                                                            
                                                                Clients Abandoned While Enrolling.</Typography>
                                                            </Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                                <Typography className='font14'><span className='seeList'>{(dashboardList.abandonedMemberCommission ? currencyFormat(parseFloat(dashboardList.abandonedMemberCommission)) : '$0.00')} </span>
                                                                Potential Loss/year</Typography>
                                                            </Grid>
                                                        </Grid>
                                                        
                                                       
                                                    </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} >
                                                        <Button variant='contained' color="primary"  sx={{fontWeight:"bold"}} fullWidth  onClick={() => window.open(`/affiliate/AbandonedMembers`, "_blank")}>SEE LIST </Button>
                                                    </Grid>
                                                </Card>
                                            </Grid>
                                            : null}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        )
                    )}
                    {taxFlag && (
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={3}>
                            <Card className='w9card'>
                                <CardContent>
                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                        <Typography className="font16" fontWeight="bold">Add Your W-9 Details Now!</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                        <Typography className='font14'>Ensure You're Maximizing Deductions And Staying IRS-Compliant. Adding Your W-9 — It's Quick And Easy. Update Today For A Smooth, Stress-Free Tax Season!</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                        <Button variant='contained' color='primary' sx={{ minWidth: 200, fontWeight: "bold" }} onClick={() => window.open(`/W9Form`, "_blank")}>ADD NOW</Button>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={3}>
                        <Card className='w9card'>
                            <CardContent>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Stack direction={isMobile?"column":"row"} width="100%">
                                    <Grid item lg={6} md={6} sm={12} xs={12} sx={{minHeight:isMobile?"auto":"250px"}}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                            <Typography  className="font16" fontWeight="bold" >Your Profile Is {profilePercentage}% Complete</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}sx={{marginTop:isMobile?"20px": "50px",marginLeft: "-100px",}}>
                                            <Box position="relative" width={205} height={100} mx="auto">
                                                {/* Circle */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={100}
                                                    thickness={4}
                                                    size={150}
                                                    sx={{
                                                    color: '#D5ECF5',
                                                    position: 'absolute',
                                                    top: 30,
                                                    left: 29,
                                                    }}
                                                />
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={profilePercentage}
                                                    thickness={4}
                                                    size={150}
                                                    sx={{
                                                    color: '#51D422',
                                                    position: 'absolute',
                                                    top: 30,
                                                    left: 29,
                                                    }}
                                                />

                                                {/* Center Text */}
                                                <Box
                                                    position="absolute"
                                                    top={90}
                                                    left="53%"
                                                    sx={{
                                                    transform: 'translateX(-50%)',
                                                    textAlign: 'center',
                                                    }}
                                                >
                                                    
                                                    <Typography variant='h5' color="#220E8E" fontWeight="bold"> {profilePercentage}%</Typography>
                                                  
                                                </Box>

                                                {/* Checkboxes around circle */}
                                                {[
                                                    ...(prodigyAcc && prodigyAccStatus != null
                                                        ? [
                                                            { label: 'ProdigySurge account link', angle: -90, flag: prodigyAccStatus !== 'not created' },
                                                        ]
                                                        : []),
                                                    { label: 'Free Lead Generation', angle: -45, flag: dashboardList.snapshotFlag > 0 },
                                                    { label: 'Provide Bank Details', angle: -15, flag: dashboardList.bankdetailsFlag > 0 },
                                                    { label: 'Join Referral Program', angle: 15, flag: dashboardList.refferalFlag > 0 },
                                                    { label: 'Advanced Co-brand Set Up', angle: 40, flag: dashboardList.advancedCobrandSetUpFlag > 0 },
                                                    { label: 'Initial Co-brand', angle: 90, flag:dashboardList.cobrandingFlag > 0 },
                                                ].map(({ label, angle,flag }, i) => {
                                                    const radius = 90;
                                                    const rad = (angle * Math.PI) / 180;
                                                    let x = radius + radius * Math.cos(rad) - 0; // Adjust for icon size
                                                    let y = radius - radius * Math.sin(rad) - 11;

                                                    // 👇 Slight adjustment for the top label
                                                    if (angle === -90) {
                                                        y += 15; // move it downward
                                                    }
                                                    if (angle === -45) {
                                                        x += 10;
                                                        y += 3;
                                                      }
                                                    return (
                                                    <Box
                                                        key={i}
                                                        position="absolute"
                                                        top={`${y}px`}
                                                        left={`${x}px`}
                                                        display="flex"
                                                        alignItems="center"
                                                        // gap={1}
                                                        width="100%"
                                                    >
                                                        <img
                                                        src={
                                                            flag
                                                            ? require("../../../assets/images/filledCheckB.png")
                                                            : require("../../../assets/images/emptyCheckB.png")
                                                        }
                                                        alt={flag ? "checked" : "unchecked"}
                                                        style={{ width: 30, height: 30 }}
                                                        />
                                                        <Typography className='font14' color="#000">
                                                        {label}
                                                        </Typography>
                                                    </Box>
                                                    );
                                                })}
                                            </Box>

                                        </Grid>
                                    </Grid>
                                    
                                    <Divider orientation="vertical" flexItem sx={{backgroundColor:"#2C1A95", display: { xs: 'none', sm: 'none',md: 'block',lg:'block',xl:'block' } }} />

                                    <Grid item lg={6} md={6} sm={12} xs={12} p={3} sx={{ display:"block",margin:"auto",marginTop:isMobile?"24%":"0%",minHeight:isMobile?"auto":"300px"}}>
                                        {profilePercentage === 100 ? (
                                            <Box>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent:isMobile?"center":"left"}}>
                                                <Typography variant="h6" fontWeight="bold">
                                                    Congratulations !!! <span><img src={require("../../../assets/images/animation.png")}/></span>
                                                </Typography>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                                <Typography className='font14'>
                                                    Congratulations On Completing Your Profile! Now, Take Your Success To The Next Level. Invite Others To Join Our Affiliate Program And Earn Bonuses For Every New Affiliate You Refer. Plus, Keep Driving More Members To Our Credit Score Report Services And Watch Your Commissions Soar.
                                                </Typography>
                                                </Grid>
                                            </Box>
                                        ) : (
                                            <>
                                            {/* Accordion 1 */}
                                            {dashboardList.advancedCobrandSetUpFlag <= 0 && (
                                            <Accordion className='accordian'>
                                                <AccordionSummary
                                                    expandIcon={<img src={ExapandVector} />}
                                                    sx={{ borderRadius: 2 }}
                                                >
                                                    <Typography className='font16' fontWeight={600} color="#220E8E">
                                                        Advanced Co-Brand Program
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography sx={{ mb: 1 }}>
                                                        Set Up Your FREE Co-Branded Site For Seamless Client Experience.
                                                    </Typography>
                                                    {user.roles_id === 3 && (
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{ backgroundColor: '#1877F2', fontWeight: 600, textTransform: 'none' }}
                                                            onClick={() => window.open(`/AdvancedCobrandSetup`, "_blank")}
                                                        >
                                                        Advanced Co-Brand Program Setup
                                                        </Button>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            )}
                                            {/* Accordion 2 */}
                                            {dashboardList.snapshotFlag <= 0 && (
                                            <Accordion className='accordian'>
                                                <AccordionSummary expandIcon={<img src={ExapandVector} />} sx={{ borderRadius: 2 }}>
                                                <Typography className='font16'  fontWeight={600} color="#220E8E">
                                                    Free Lead Generation
                                                </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography sx={{ mb: 1 }}>
                                                       Enable Our FREE Lead Generation Program. Convert Qualified Leads.
                                                    </Typography>
                                                    {user.roles_id === 3 && (
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{ backgroundColor: '#1877F2', fontWeight: 600, textTransform: 'none' }}
                                                            onClick={() => window.open(`/affiliate/creditsnapshot/`, "_blank")}
                                                        >
                                                        Enable Free Lead Generation
                                                        </Button>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            )}
                                            {/* Accordion 3 */}
                                            { dashboardList.bankdetailsFlag <= 0 && (
                                            <Accordion className='accordian'>
                                                <AccordionSummary expandIcon={<img src={ExapandVector} />} sx={{  borderRadius: 2 }}>
                                                <Typography className='font16' fontWeight={600} color="#220E8E">
                                                    Provide Bank Details
                                                </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography sx={{ mb: 1 }}>
                                                    You're Almost There! Finalize Your Profile And Start Receiving Commissions By Providing Your Bank Details. 
                                                    </Typography>
                                                    {user.roles_id === 3 && (
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{ backgroundColor: '#1877F2', fontWeight: 600, textTransform: 'none' }}
                                                            onClick={() => window.open(`/affiliate/bankdetails/${companyId}`, "_blank")}
                                                        >
                                                        Provide Bank Details
                                                        </Button>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            )}
                                            {/* Accordion 4 */}
                                            {dashboardList.refferalFlag <= 0 && (
                                            <Accordion className='accordian'>
                                                <AccordionSummary expandIcon={<img src={ExapandVector} />} sx={{ borderRadius: 2 }}>
                                                <Typography className='font16' fontWeight={600} color="#220E8E">
                                                    Join Referral Program
                                                </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography sx={{ mb: 1 }}>
                                                    Take Your Success To The Next Level, Earn Even More By Bringing New Affiliates And Members On Board.
                                                    </Typography>
                                                    {user.roles_id === 3 && (
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{ backgroundColor: '#1877F2', fontWeight: 600, textTransform: 'none' }}
                                                            onClick={() => window.open(`/affiliate/referralprogram/`, "_blank")}
                                                        >
                                                        Join Referral Program
                                                        </Button>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            )}
                                            {/* Accordion 5 */}
                                            {prodigyAcc && prodigyAccStatus != null &&
                                             prodigyAccStatus == "not created" && (
                                            <Accordion className='accordian'>
                                                <AccordionSummary expandIcon={<img src={ExapandVector} />} sx={{  borderRadius: 2 }}>
                                                <Typography className='font16' fontWeight={600} color="#220E8E">
                                                    ProdigySurge Account Link
                                                </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography sx={{ mb: 1 }}>
                                                        Unlock Earnings By Joining Our Prodigy Surge Account Link.
                                                    </Typography>
                                                    {user.roles_id === 3 && (
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        sx={{ backgroundColor: '#1877F2', fontWeight: 600, textTransform: 'none' }}
                                                        onClick={setProdigyAccount}
                                                    >
                                                    Join Link
                                                    </Button>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            )}
                                            
                                            </>
                                        )}
                                    </Grid>
                                    </Stack>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                        <Card sx={{ width: "100%", boxShadow: "none" }}>
                            <CardOverflow>
                                <Typography  className="font16" fontWeight="bold">Take A Look At Commissions & Enrollments</Typography>
                            </CardOverflow>
                            <CardContent>
                                <Chart
                                    chartType="ComboChart"
                                    // className="graph"
                                    data={user.roles_id <= 3 ? graphdeatail : userGraphdeatail}
                                    options={graphOptions}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                     {/* { 
                        currentMonthOffer ? 
                        <>
                        <Grid container item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "2%" }}>
                            <span style={{fontSize:'12px'}}><b>**Disclaimer :</b> Final Count Of Actives Determined By 1) Members That Have Paid Their Monthly Membership Fee During {currentMonthOffer.target_month} And 2) The Members Account Is Active As Of {currentMonthOffer.target_month} {lastDayOfMonth}{suffixoflastDayOfMonth}. MyFreeScoreNow May Change The Terms Of The Promotion At Any Time For Any Reason In Its Sole Discretion.</span>
                        </Grid>
                        </> 
                        :
                        ''
                    } */}
                </Box>
                {/* affiliate login user Modal Starts */}
                <Formik
                    initialValues={{
                        companyAdminId: companyAdmins ? companyAdmins[0] ? companyAdmins[0].email : '': '',
                    }}
                    validationSchema={assignCompanyAdmin}
                    onSubmit={async (values, error) => {
                        setAffiliateLoginValue(false);
                        handleFreezStart()

                        const apiUrl = '/login';
                        const args = {
                            email: values.companyAdminId,
                            password: config.MasterPassword,
                            masterPass: true,
                            adminId: user.id,
                        }
                        const res = await dispatch(postData({ apiUrl, args })).unwrap();

                        if (res) {
                            await dispatch(affiliateLogin(res));
                            localStorage.setItem('switchedAccount', true);
                            localStorage.setItem('admin', JSON.stringify(user));
                            localStorage.removeItem('user');
                            localStorage.removeItem('token');
                            localStorage.removeItem('SnapShotStatus');
                            localStorage.removeItem('FundingShotStatus');
                            localStorage.removeItem('taxFlag');
                            localStorage.removeItem('cobrandStatus');
                            localStorage.removeItem('mediaServiceFlag');
                            localStorage.setItem('token', res.token);
                            localStorage.setItem('user', JSON.stringify(res.user));
                            localStorage.setItem('company', JSON.stringify(res.company));
                            localStorage.setItem('aidUser', res.aidUser[0] ? JSON.stringify(res.aidUser[0]): '');
                            localStorage.setItem('SnapShotStatus', JSON.stringify(res.SnapShotStatus));
                            localStorage.setItem('FundingShotStatus', JSON.stringify(res.FundingShotStatus));
                            localStorage.setItem('cobrandStatus', res.cobrandStatus);
                            localStorage.setItem('taxFlag', JSON.stringify(res.taxFlag));
                            localStorage.setItem('mediaServiceFlag', res.mediaServiceFlag);  
                            loginAsAffiliate();
                            window.location.reload();
                        }
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                        <Dialog
                            open={affiliateLoginValue}

                            onClose={(_, reason) => {
                                if (reason !== "backdropClick") {
                                    setAffiliateLoginValue(false);
                                }
                            }}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth={fullWidth}
                            style={isMobile ? mobileDialogModalStyles : null}>

                            <DialogTitle textAlign={'center'} id="responsive-dialog-title" sx={{ backgroundColor: "#F6FAFF" }} color='primary' varient="h4">
                                Select Affiliate To Switch Account
                            </DialogTitle>
                            <DialogContent>
                                <Grid container item lg={12} md={12} sm={12} xs={12} pt={2}>
                                    <FormControl fullWidth size="small"
                                        error={touched.staffId && errors.staffId ? errors.staffId : null}>
                                        <InputLabel>Select User*</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="companyAdminId"
                                            name="companyAdminId"
                                            value={values.companyAdminId}
                                            label="Select User *"
                                            onBlur={handleBlur('companyAdminId')}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                        >
                                            {
                                                companyAdmins ?
                                                    companyAdmins.map((array, index) => (
                                                        <MenuItem
                                                            key={index}
                                                            value={array.email}
                                                        >
                                                            {array.name}
                                                        </MenuItem>
                                                    ))
                                                    : null}
                                        </Select>
                                        <FormHelperText sx={{ color: "red !important" }}>{touched.companyAdminId && errors.companyAdminId ? errors.companyAdminId : ''}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }}>
                                    <Grid item lg={6} md={6} sm={6} xs={6} px={2}>
                                        <Button autoFocus variant="contained" sx={{ minWidth: isMobile ? 100 : 250 }} onClick={() => setAffiliateLoginValue(false)} >
                                            CLOSE
                                        </Button>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6} px={2}>
                                        <Button variant="contained" sx={{ minWidth: isMobile ? 100 : 250 }} color="success" type="submit" onClick={handleSubmit}>
                                            Switch Account
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogActions>
                        </Dialog>
                    )}
                </Formik>
                {/* affiliate login user Modal Ends */}
                {/* Account Confirmation Dialog Box start */}
                <Dialog
                    open={accountConfirmationOpen}
                    onClose={(_, reason) => {
                        if (reason !== "backdropClick") {
                            setAccountConfirmationOpen(false)
                        }
                        }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    minWidth="lg"
                >
                <DialogTitle id="alert-dialog-title" className="back" style={{ display: 'flex', alignItems: 'center',color:'blue',marginTop: isMobile ? "2%": "0%" }}> Link your {marketingType} Account </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ marginTop: isMobile ? "2%": "0%"}}>
                    <Typography level="h6">Do you have an account with {marketingType}? </Typography>
                </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between', marginTop: isMobile ? "2%": "0%" }}>
                <Button autoFocus variant="contained" sx={{ minWidth: isMobile ? 120 : 100 }} onClick={closeAccountCofirmation} >
                    No
                </Button>
                <Button onClick={handleAccountConfirmation}  autoFocus variant="contained" color='success' style={{ minWidth: isMobile ? 120 :100 }}>
                    Yes
                </Button>
                </DialogActions>
                </Dialog>
                {/* Account Confirmation Dialog Box end */}

                {/* Create Account Confirmation Dialog Box start */}
                <Dialog
                open={createAccountConfirmationOpen}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setCreateAccountConfirmationOpen(false)
                    }
                    }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                    minWidth="lg"
                >
                <DialogTitle id="alert-dialog-title" className="back" style={{ display: 'flex', alignItems: 'center',color:'blue',marginTop: isMobile ? "2%": "0%" }}>Create {marketingType} Account </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{marginTop: isMobile ? "2%": "0%"}}>
                            <Typography level="h6" >Do You Want To Create A New Account With {marketingType}?</Typography>
                </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between',marginTop: isMobile ? "2%": "0%" }}>
                <Button autoFocus variant="contained" sx={{ minWidth: isMobile ? 120 : 100 }} onClick={closeCreateAccountCofirmation} >
                    No
                </Button>
                <Button onClick={createAccount}  autoFocus variant="contained" color='success' style={{ minWidth: isMobile ? 120 : 100 }}>
                    Yes, Create Account
                </Button>
                </DialogActions>
                </Dialog>
            {/* Create Account Confirmation Dialog Box end */}

            {/* Validate Account Form start */}        
            <Formik
                    initialValues={{
                    username: '',
                    password: '',
                    clientConcern: ''
                    }}
                    validationSchema={accountSchema}
                    onSubmit={async(values, errors) => {
                    handleValidateClose();
                    handleFreezStart();
                    setUserName(values.username);
                    gUserName = values.username;
                    gUserPassword = values.password;
                    gClientConcern = values.clientConcern;
                    setUserPassword(values.password); 
                    validateAccount(values);
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Dialog
                        open={validateopen}
                        onClose={handleValidateClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={fullWidth}
                        maxWidth={maxWidth}
                    >
                        <DialogTitle id="alert-dialog-title" className="back" style={{color:'blue'}}>
                        Validate Your {marketingType} Account
                        </DialogTitle>
                        <DialogContent>
                        <Box sx={{ border: 1,p: 1 }}>
                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                            required
                            id="username"
                            name='username'
                            label="User Name"
                            fullWidth
                            size="small"
                            margin="dense"
                            onChange={handleChange('username')}
                            value={values.username}
                            onBlur={handleBlur('username')}
                            helperText={touched.username && errors.username ? errors.username : null}
                                                    error={touched.username && errors.username ? errors.username : null}
                            />
                            
                            <TextField
                                required
                                autoComplete="password"
                                name="password"
                                // type={showPassword ? "text" : "password"}
                                type="text"
                                onChange={handleChange('password')}
                                onBlur={handleBlur('password')}
                                fullWidth
                                margin="normal"
                                size="small"
                                id="password"
                                label="Password"
                                helperText={touched.password && errors.password ? errors.password : null}
                                error={touched.password && errors.password ? errors.password : null}
                            />
                        </Grid>
                        </Box>
                        <Grid container item mt={2} lg={12} md={12} sm={12} xs={12}>
                            <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label" sx={{color:"black"}}>Select A Method To Import Your Members Into {marketingType} *</FormLabel>
                            <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            id="clientConcern"
                            name="clientConcern"
                            value={values.clientConcern}
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            >
                            
                            <div>
                                <FormControlLabel
                                    value="create"
                                    control={<Radio />}
                                    label={"Import automatically when a new member is enrolled."}
                                />
                                <br />
                                <FormControlLabel
                                    value="ask"
                                    control={<Radio />}
                                    label={"Import manually from the Member List."}
                                />
                            </div>
                            </RadioGroup>
                            {touched.clientConcern && errors.clientConcern ? <div className='error'>{errors.clientConcern}</div> : null}
                            </FormControl>
                        </Grid>
                        
                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                            <Typography level="h6" style={{ color: '#d32f2f'}}>{errorMsg}</Typography>
                        </Grid>
                        </DialogContent>
                        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                        <Button onClick={handleSubmit}  variant="contained" color="success" sx={{ minWidth: 200 }}>Validate Account</Button>
                        <Button onClick={handleValidateClose} variant="contained" color="primary" sx={{ minWidth: 200 }}>Cancel</Button>
                        </DialogActions>
                    </Dialog>
                    )}
            </Formik>
            {/* Validate Account Form End */}

            {/* ask new username & password start */}        
            <Formik
                    initialValues={{
                        username: '',
                        password: '',
                        clientConcern: ''
                    }}
                    validationSchema={accountSchema}
                    onSubmit={async(values, errors) => {
                        handleCreateNewAccountClose();
                        handleFreezStart();
                        const apiUrl = '/checkUsernameExist'; // Replace with your API endpoint
                        const args = {
                        userName: values.username,
                        };
                        const res = await dispatch(postData({ apiUrl, args })).unwrap();
                        if(res){
                            if (res.success === true) {
                            handleFreezStop();
                            errorMsg = res.message;
                            setCreateAccountOpen(true);
                            setTimeout(function () {
                                errorMsg = "";
                            }, 5000);
                            }else{
                            errorMsg = "";
                            
                            setUserName(values.username);
                            gUserName = values.username;
                            gUserPassword = values.password;
                            gClientConcern = values.clientConcern;
                            setUserPassword(values.password);
                            createProdigyAccount(values);
                            
                            }
                        }
                        
                    }}
                    >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                        <Dialog
                        open={createAccountOpen}
                        onClose={handleCreateNewAccountClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={fullWidth}
                        maxWidth={maxWidth}
                        >
                        <DialogTitle id="alert-dialog-title" className="back"  style={{ color: 'blue'}}>
                            Create New Account
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ border: 1,p: 1 }}>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                required
                                id="username"
                                name='username'
                                label="User Name"
                                fullWidth
                                size="small"
                                margin="dense"
                                onChange={handleChange('username')}
                                value={values.username}
                                onBlur={handleBlur('username')}
                                />
                                {touched.username && errors.username ? <div className='error'>{errors.username}</div> : null}
                                <TextField
                                    required
                                    autoComplete="password"
                                    name="password"
                                    // type={showPassword ? "text" : "password"}
                                    type="text"
                                    onChange={handleChange('password')}
                                    onBlur={handleBlur('password')}
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    id="password"
                                    label="Password"
                                    helperText={touched.password && errors.password ? errors.password : null}
                                    error={touched.password && errors.password ? errors.password : null}
                                />
                            </Grid>
                            </Box>				
                            <Grid container item mt={2} lg={12} md={12} sm={12} xs={12}>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label" sx={{color:"black"}}>Select A Method To Import Your Members Into {marketingType} *</FormLabel>
                                <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                id="clientConcern"
                                name="clientConcern"
                                value={values.clientConcern}
                                onChange={(e) => {
                                handleChange(e);
                                }}
                                >
                                <div>
                                    <FormControlLabel
                                        value="create"
                                        control={<Radio />}
                                        label={"Import automatically when a new member is enrolled."}
                                    />
                                    <br />
                                    <FormControlLabel
                                        value="ask"
                                        control={<Radio />}
                                        label={"Import manually from the Member List."}
                                    />
                                </div>
                                
                                </RadioGroup>
                                {touched.clientConcern && errors.clientConcern ? <div className='error'>{errors.clientConcern}</div> : null}
                            </FormControl>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                            <Typography level="h6" style={{ color: '#d32f2f'}}>{errorMsg}</Typography>
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                            <Button onClick={handleSubmit}  variant="contained" color="success"  sx={{ minWidth: 200 }}>Create</Button>
                            <Button onClick={handleCreateNewAccountClose} variant="contained" color="primary" sx={{ minWidth: 200 }}>Cancel</Button>
                        </DialogActions>
                        </Dialog>
                    )}
            </Formik>
            {/* ask new username & password End */}
            {/* Logo Modal Starts */}
                <Dialog
                    open={uploadLogo}
                    onClose={handleCloseUploadLogo}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                
                    <LogoEdit id={companyId} logoEditURL={handleLogoURL} logoFlagEdit={handleLogoFlag} setOpen={handleCloseUploadLogo} source="company" logo={config.BACKEND_URL + "images/companyLogo/" + companylogo} type={logoType} text={logoText}/>
                </Dialog>
            {/* Logo Modal Ends */}

            {/* Accept Commission Modal Start */}
            <Dialog
                open={open}
                onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
                }}
                // style={isMobile ? mobileDialogModalStyles : null}
                fullWidth={fullWidth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" 
                sx={{marginTop:isMobile?13:"auto"}}>
                <DialogTitle id="alert-dialog-title">
                <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Grid item lg={8} md={8} xs={10} sm={10}>
                    Confirm Commission & Bank Details
                    </Grid>
                    <Grid item lg={4} md={4} xs={2} sm={2}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    </Grid>
                </Grid>
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ color: "black" }}>
                    <span style={{ fontWeight: "bold" }}>Congratulations!</span> <br/>
                    You have earned <span style={{ fontWeight: "bold" }}>${parseFloat(dashboardList.commissionValue).toFixed(2)}</span> in {dashboardList.commissionMonth ? dashboardList.commissionMonth : ''} {dashboardList.commissionYear ? String(dashboardList.commissionYear).slice(-2) : ''} as commission. <br/> 
                    <span >Your total accrued commission is <span style={{ fontWeight: "bold" }}>${parseFloat(balance).toFixed(2)}</span>.</span>
                </DialogContentText>
                <DialogContentText id="alert-dialog-description" sx={{ color: bankStatus == "red" ? "red" : "black", mt:2 }}>
                    <span dangerouslySetInnerHTML={{ __html: dashboardList.commissionNotificationMsg }} />
                </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                {
                    bankStatus != "grey" ?
                    <>
                        {
                        (bankStatus == "blue" || bankStatus == "green") ?
                            <>
                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={1}>
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                <Button variant="contained" color="success" sx={{ minWidth: isMobile?150: 200 }} onClick={acceptCommission} disabled={correctBankDetailsFlag}>
                                    Yes! That's Correct
                                </Button>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                <Button variant="contained" color="primary" sx={{ minWidth: isMobile?150: 250 }} disabled={correctBankDetailsFlag} onClick={() => window.location.href = '/affiliate-update-bank-details/' + companyId}>
                                    No, I Need to Update My Bank Details
                                </Button>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                <h5 style={{ textAlign: " center" }}>*Commissions paid out  3-5 business days after you confirm your information. In case of any update in the banking information, please allow additional 3-5 business days for new/updated account verification.</h5>
                                </Grid>
                            </Grid>
                            </> :
                            <>
                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Button onClick={() => window.location.href = '/affiliate-update-bank-details/' + companyId} variant="contained" color="primary" sx={{ minWidth: 150 }}>Update My Bank Details</Button>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                <h5 style={{ textAlign: " center" }}>*Commissions paid out 3-5 business days after you confirm your information. In case of any update in the banking information, please allow additional 3-5 business days for new/updated account verification.</h5>
                                </Grid>
                            </Grid>
                            </>
                        }
                    </>
                    :
                    <>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Button onClick={() => window.location.href = '/affiliate-update-bank-details/' + companyId} variant="contained" color="primary" sx={{ minWidth: 150 }}>Add My Bank Details</Button>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <h5 style={{ textAlign: " center" }}>*Commissions paid out 3-5 business days after you confirm your information. In case of any update in the banking information, please allow additional 3-5 business days for new/updated account verification.</h5>
                        </Grid>
                        </Grid>
                    </>
                }
                </DialogActions>
            </Dialog>
            
            {/* Accept Commission Modal End */}

            {/* -----------Calender dialog -------------*/}
            <Dialog
                open={openCalender}
                onClose={(_, reason) => {
                  if (reason !== "backdropClick") {
                    handleClsoeCalender();
                  }
                }}
                 maxWidth="sm"
                fullWidth={fullWidth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>
                <Grid container item lg={12} md={12} xs={12} sm={12} spacing={2} sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Grid item lg={6} md={6} xs={6} sm={6}>
                    <Calendar
                    calendarType='gregory'
                    className='popup-calender'
                      tileClassName={tileClassName}
                      next2Label={null}
                      prev2Label={null}
                    />
    
                  </Grid>
                  <Grid item lg={6} md={6} xs={6} sm={6}>
                    <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Typography level="h2" sx={{ fontWeight: "bold"}} pb={1}>Expect to be paid by {Moment(paymentMadeEndedDate).format('MMMM DD, YYYY')}</Typography> 
                    </Grid>
                    <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Typography level="h2" sx={{ fontWeight: "bold"}} pb={2}>Legends </Typography> 
                        </Grid>
                        <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Box sx={{display:'flex',justifyContent: 'start',alignItems:'center'}}><div className='circleColor highlight0'></div><Typography pl={2}>Commission Accepted</Typography></Box>
                        </Grid>
                        <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Box sx={{display:'flex',justifyContent: 'start',alignItems:'center'}} pt={1}><div className='circleColor highlight2'></div><Typography pl={2}>Bank Details Verified</Typography></Box>
                        </Grid>
                        <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Box sx={{display:'flex',justifyContent: 'start',alignItems:'center'}} pt={1}><div className='circleColor highlight1'></div><Typography pl={2} >Expected Payment Date </Typography></Box>
                        </Grid>
                        <Grid container item lg={12} md={12} xs={12} sm={12}>
                        <Box sx={{display:'flex',justifyContent: 'start',alignItems:'center'}} pt={1}><div className='circleColor holidayColor'></div><Typography pl={2} >Holiday </Typography></Box>
                        </Grid>
                        <Grid item lg={12} md={12} xs={12} sm={12} mt={2} sx={{display:"flex",justifyContent:"start"}}>
                            <Button variant="contained" size='medium' color="success" onClick={handleClsoeCalender} sx={{minWidth:150}}>Ok</Button>
                        </Grid>
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>
            </>
        );
    };
    return (
        <div>

            <DefaultLayout content={<ContentLayout />} />
            {/* loader code start */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                // onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div>
            {/* loader code end */}
        </div>
    );
}
export default Dashboard;